<template>
  <div class="container intelligent home_page">
    <div class="info_nav">
      <van-icon name="arrow-left" class="back" @click="goBack" />
      <div>{{ scoreHistory && navData.score }}分</div>
      <div style="padding: 0 10px">
        {{ scoreHistory && navData.value }}
      </div>
      <div style="padding: 0 0">{{ routerData.bzType }}批次</div>
    </div>
    <!--    el-tabs（自定义label） 三个页面 院校优先、专业优先、职业优先 -->
    <div class="tab-box">
      <div class="tab">
        <div class="top fill_tabs_box">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
            <el-tab-pane label="" name="college">
              <span slot="label" class="nav"><i class="iconfont icon-pcyuanxiao"></i> 院校优先</span>
              <van-dropdown-menu>
                <van-dropdown-item v-for="(item, i) in filterOption" :key="i" :title="item.name" :ref="'item_' + i">
                  <div class="filter-list">
                    <div class="filter-list-title">{{ item.name }}</div>
                    <div class="filter-list-tags">
                      <div class="tag">
                        <div class="tag_box" :class="filterData[item.type].length === 0 ? 'active' : ''"
                          @click="filterClick(i, -1)">
                          不限
                          <i v-if="filterData[item.type].length === 0" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                      <div class="tag" v-for="(tag, t) in item.list" :key="t">
                        <div class="tag_box" v-if="tag.name == '新增院校' || tag.name == '非新增院校'"
                          :class="tag.isChecked ? 'active' : ''" @click="filterClick(i, t, 'newCollege')">
                          {{ tag.name }}
                          <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                        </div>
                        <div class="tag_box" v-else :class="tag.isChecked ? 'active' : ''" @click="filterClick(i, t)">
                          {{ tag.name }}
                          <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter-action">
                    <button class="van-button van-button--primary van-button--large" @click="clickFillBtn(i)">
                      确定
                    </button>
                  </div>
                </van-dropdown-item>
              </van-dropdown-menu>
              <div class="filter-list pb20" style="border: none">
                <span style="display: none" class="filter-list-title">意向院校</span>
                <div class="filter-list-tags search_box">
                  <el-autocomplete v-model="filterData.keyword" prefix-icon="el-icon-search" :fetch-suggestions="search"
                    placeholder="请输入意向院校" clearable @select="handleSelect" @clear="handleSelectClear">
                    <template slot-scope="{ item }">
                      <div class="name" v-html="highLightText(item.value, filterData.keyword)"></div>
                    </template>
                  </el-autocomplete>
                  <!--                  <el-input prefix-icon="el-icon-search" v-model="filterData.keyword" placeholder="请输入意向院校"-->
                  <!--                  clearable></el-input>-->
                </div>
              </div>
              <div class="myFilterRecordBlockRow" v-if="false">
                <div class="fill_box_title">筛选条件：</div>
                <div class="customer-selected-tags">
                  <div class="tag" v-for="(tag, index) in filterDataArr" :key="index">
                    {{ tag.name }}
                    <i class="el-icon-close" @click="removeFilterDataItem(tag)"></i>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="专业优先" name="major">
              <span slot="label" class="nav"><i class="iconfont icon-pczhuanye"></i> 专业优先</span>
              <van-dropdown-menu>
                <van-dropdown-item title="专业选择" ref="item_21">
                  <div class="filter-list">
                    <div class="filter-list-title">专业选择</div>
                    <div class="filter-list-tags">
                      <div class="tag" v-for="(tag, i) in majorFilterOption.features" :key="i">
                        <div class="tag_box" :class="tag.isChecked ? 'active' : ''" @click="changeMajorType(tag.name)">
                          {{ tag.name }}
                          <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="filter-list-title">专业选择</div>
                    <div class="filter-list-tags">
                      <div class="tag">
                        <div class="tag_box" :class="majorFilterData['majorList'].length === 0 ? 'active' : ''"
                          @click="majorFilterClick(-1, 'majorList')">
                          不限({{ majorList.list.length }})
                          <i v-if="majorFilterData['majorList'].length === 0" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="fill_tabs_box_tags">
                      <van-sidebar v-model="activeMajorKey">
                        <van-sidebar-item v-for="(tag, i) in majorList.list"
                          :title="tag.name + '(' + tag.major.length + ')'" :key="i" />
                      </van-sidebar>
                      <div class="right_box">
                        <div class="filter-list-tags">
                          <div class="tag" style="width: auto"
                            v-for="(item, index) in majorList.list[activeMajorKey] && majorList.list[activeMajorKey].major"
                            :key="index">
                            <div class="tag_box" style="padding: 0 10px"
                              :class="majorFilterData.majorList.filter((e) => e.name == item.name).length > 0 ? 'active' : ''"
                              @click="setMajorFilter(item)">
                              {{ item.name }}
                              <i v-if="majorFilterData.majorList.filter((e) => e.name == item.name).length > 0"
                                class="el-icon-check tag_icon"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter-action">
                    <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(21)">
                      确定
                    </button>
                  </div>
                </van-dropdown-item>
                <van-dropdown-item :title="majorFilterOption.majorType.name" ref="item_22">
                  <div class="filter-list">
                    <div class="filter-list-title">
                      {{ majorFilterOption.majorType.name }}
                    </div>
                    <div class="filter-list-tags">
                      <div class="tag">
                        <div class="tag_box" :class="majorFilterData.majorType.length === 0 ? 'active' : ''"
                          @click="majorFilterClick(-1, 'majorType')">
                          不限
                          <i v-if="majorFilterData.majorType.length === 0" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                      <template v-for="(tag, index) in majorFilterOption.majorType.list">
                        <div class="tag" v-if="tag.name == '新增专业' || tag.name == '非新增专业'">
                          <div class="tag_box" :class="tag.isChecked ? 'active' : ''"
                            @click="majorFilterClick(index, 'newMajor')">
                            {{ tag.name }}
                            <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                          </div>
                        </div>
                        <div class="tag" v-else>
                          <div class="tag_box" :class="tag.isChecked ? 'active' : ''"
                            @click="majorFilterClick(index, 'majorType')">
                            {{ tag.name }}
                            <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="filter-action">
                    <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(22)">
                      确定
                    </button>
                  </div>
                </van-dropdown-item>
                <van-dropdown-item :title="majorFilterOption.cost.name" ref="item_23">
                  <div class="filter-list">
                    <div class="filter-list-title">
                      {{ majorFilterOption.cost.name }}
                    </div>
                    <div class="filter-list-tags">
                      <div class="tag">
                        <div class="tag_box" :class="majorFilterData.cost.length === 0 ? 'active' : ''"
                          @click="costFilterClick(-1, 'cost')">
                          不限
                          <i v-if="majorFilterData.cost.length === 0" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                      <template v-for="(tag, index) in majorFilterOption.cost.list">
                        <div class="tag" style="width: auto">
                          <div class="tag_box" :class="tag.isChecked ? 'active' : ''" @click="costFilterClick(index)"
                            style="padding: 0 12px">
                            {{ tag.name }}
                            <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="filter-action">
                    <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(23)">
                      确定
                    </button>
                  </div>
                </van-dropdown-item>
              </van-dropdown-menu>

              <div class="filter-list pb20" style="border: none">
                <!-- <span class="filter-list-title">我的关注</span> -->
                <div class="filter-list-tags search_box">
                  <el-autocomplete v-model="majorFilterData.keyword" prefix-icon="el-icon-search"
                    :fetch-suggestions="search" placeholder="请输入意向专业" clearable @select="handleSelect"
                    @clear="handleSelectClear">
                    <template slot-scope="{ item }">
                      <div class="name" v-html="highLightText(item.value, majorFilterData.keyword)"></div>
                    </template>
                  </el-autocomplete>
                  <!--                  <el-input prefix-icon="el-icon-search" v-model="filterData.keyword" placeholder="请输入意向院校"-->
                  <!--                  clearable></el-input>-->
                </div>
                <!-- <span class="filter-list-title m-r-15 m-l-30">用户测评</span> -->
                <div style="z-index: 3; padding: 15px 15px 0">
                  <el-select style="width: 100%" v-model="userEvaluation" value-key="value" collapse-tags multiple
                    placeholder="请选择用户测评" @change="handleSelectMajor">
                    <el-option v-for="item in majorTestList" :key="item.value" :label="item.name" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div style="display: flex; padding: 0px 32px 30px">
                <span class="m-r-30" style="font-weight: 500">选科高级筛选</span>
                <div style="position: relative">
                  <div class="show_vip" v-if="!isShowMore" @click="isShowVip"></div>
                  <p>
                    <el-checkbox :label="item" v-for="(item, index) in planConfig.course" :key="index"
                      v-model="chooseSubject" @change="highFilter($event, item)"></el-checkbox>
                  </p>
                </div>
              </div>
              <div class="myFilterRecordBlockRow" v-if="false">
                <div class="fill_box_title">筛选条件：</div>
                <div class="customer-selected-tags">
                  <div class="tag" v-for="(tag, t) in majorFilterDataArr" :key="t">
                    {{ tag.name }}
                    <i class="el-icon-close" @click="removeMajorFilterDataItem(tag)"></i>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="职业优先" name="job">
              <span slot="label" class="nav"><i class="iconfont icon-pczhiye"></i> 职业优先</span>
              <van-dropdown-menu class="job">
                <van-dropdown-item title="职业选择" ref="item_31">
                  <div class="filter-list">
                    <div class="filter-list-title">职业选择</div>
                    <div class="filter-list-tags">
                      <div class="tag">
                        <div class="tag_box" :class="jobFilterData['jobList'].length === 0 ? 'active' : ''"
                          @click="jobFilterClick(-1, 'jobList')">
                          不限({{ jobFilterOption.jobList.list.length }})
                          <i v-if="jobFilterData['jobList'].length === 0" class="el-icon-check tag_icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="fill_tabs_box_tags">
                      <van-sidebar v-model="activeJobKey">
                        <van-sidebar-item v-for="(tag, i) in jobFilterOption.jobList.list"
                          :title="tag.name + '(' + tag.jobs.length + ')'" :key="i" />
                      </van-sidebar>
                      <div class="right_box">
                        <div class="filter-list-tags">
                          <div class="tag" style="width: auto" v-for="(item, index) in jobFilterOption.jobList.list[
        activeJobKey
      ] && jobFilterOption.jobList.list[activeJobKey].jobs" :key="index">
                            <div class="tag_box" style="padding: 0 10px" :class="jobFilterData.jobList.filter((e) => e.name == item.name)
        .length > 0
        ? 'active'
        : ''
        " @click="setJobFilter(item)">
                              {{ item.name }}
                              <i v-if="jobFilterData.jobList.filter((e) => e.name == item.name)
        .length > 0
        " class="el-icon-check tag_icon"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter-action">
                    <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(31)">
                      确定
                    </button>
                  </div>
                </van-dropdown-item>
                <van-dropdown-item> </van-dropdown-item>
                <van-dropdown-item> </van-dropdown-item>
              </van-dropdown-menu>
              <div class="filter-list pb20" style="border: none">
                <!-- <span class="filter-list-title">我的关注</span> -->
                <div class="filter-list-tags search_box">
                  <el-autocomplete v-model="jobFilterData.keyword" prefix-icon="el-icon-search"
                    :fetch-suggestions="search" placeholder="请输入意向职业" clearable @select="handleSelect"
                    @clear="handleSelectClear">
                    <template slot-scope="{ item }">
                      <div class="name" v-html="highLightText(item.name, jobFilterData.keyword)"></div>
                    </template>
                  </el-autocomplete>
                  <!--                  <el-input prefix-icon="el-icon-search" v-model="filterData.keyword" placeholder="请输入意向院校"-->
                  <!--                  clearable></el-input>-->
                </div>
              </div>
              <div class="myFilterRecordBlockRow" v-if="false">
                <div class="fill_box_title">筛选条件：</div>
                <div class="customer-selected-tags">
                  <div class="tag" v-for="(tag, t) in jobFilterDataArr" :key="t">
                    {{ tag.name }}
                    <i class="el-icon-close" @click="removeJobFilterDataItem(tag)"></i>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <div class="myFilterRecordBlockRow">
              <div class="fill_box_title" style="display: flex; justify-content: space-between; align-items: center">
                筛选条件：
                <el-button v-if="newFilterDataArr.length > 0" style="margin-left: -5px" type="text" size="mini"
                  @click="clearFilterData">清空</el-button>
              </div>
              <div class="customer-selected-tags">
                <div class="tag" v-for="(tag, t) in newFilterDataArr" :key="t">
                  {{ tag.name }}
                  <i class="el-icon-close" @click="removeItem(tag)"></i>
                </div>
              </div>
            </div>
          </el-tabs>
        </div>
        <div class="m-t-30 middle" ref="obtain">
          <div class="score-range-wrapper" ref="obtain1" :style="styleObj">
            <div class="score-range">
              <div style="
                  display: flex;
                  margin-bottom: 15px;
                  justify-content: center;
                  padding: 0 18px;
                ">
                <el-button v-if="!isShowMore" type="primary" @click="openVip" style="width: 50%">
                  开通VIP
                </el-button>
              </div>
              <div class="score-box score-box1"
                style="display: flex; align-items: center; justify-content: space-between">
                <div style="display: flex; width: 100%; align-items: center">
                  <span class="">换算分数</span>
                  <div style="width: 70vw;margin-left:1vw">
                    <table class="recentYears" style="">
                      <tr>
                        <th v-for="(item, index) in planConfig.usePlan" :key="index" @click="handleSortChange(item)">
                          <div>
                            <p class="yearName">{{ planConfig.recentYears[item - 1] }} 年</p>
                            <span>
                              <i class="el-icon-caret-top"
                                :style="yearsCheckList.year == planConfig.recentYears[item - 1] && filterData.sortOrder == 'asc' ? 'color:#910000' : ''"></i>
                              <i class="el-icon-caret-bottom"
                                :style="yearsCheckList.year == planConfig.recentYears[item - 1] && filterData.sortOrder == 'desc' ? 'color:#910000' : ''"></i>
                            </span>
                          </div>
                        </th>
                        <th @click="handleSort()">
                          <div>
                            <p class="yearName">计划增减</p>
                            <span>
                              <i class="el-icon-caret-top"
                                :style="soreType == 1 && filterData.sortOrder == 'asc' ? 'color:#910000' : ''"></i>
                              <i class="el-icon-caret-bottom"
                                :style="soreType == 2 && filterData.sortOrder == 'desc' ? 'color:#910000' : ''"></i>
                            </span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <!-- <template  > -->

                        <td align="center" v-for="(item, index) in  planConfig.usePlan">
                          {{ planConfig && planConfig.scoreList && planConfig.scoreList['score' + item] }}分
                        </td>

                        <!-- </template> -->
                        <!-- <td align="center" >
                          {{
                            this.planConfig.scoreList && this.planConfig.scoreList.score1
                          }}
                          分
                        </td>
                        <td align="center">
                          {{
                            this.planConfig.scoreList && this.planConfig.scoreList.score2
                          }}
                          分
                        </td>
                        <td align="center">
                          {{
                            this.planConfig.scoreList && this.planConfig.scoreList.score3
                          }}
                          分
                        </td> -->
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="score-box">
                <span class="m-r-30">推荐范围</span>
                <div class="slider" style="position: relative">
                  <div class="show_vip" v-if="!isShowMore" @click="isShowVip"></div>
                  <vue-slider v-model="sliderValue" :lazy="true" tooltip="none"
                    :processStyle="{ background: '#910000' }" direction="rtl" :min="planConfig.minScore"
                    :max="planConfig.maxScore" @change="handleSliderChange">
                    <p style="background: #f0f0f0; height: 4px; width: 112%"></p>
                    <template v-slot:dot="{ value }">
                      <div>
                        <span style="
                            background-color: #910000;
                            padding: 1px 10px;
                            color: #fff;
                            border-radius: 10px;
                            font-size: 12px;
                          ">{{ value }}</span>
                      </div>
                    </template>
                  </vue-slider>
                  <!-- <el-slider
                    v-model="sliderValue"
                    range
                    :max="planConfig.maxScore"
                    :min="planConfig.minScore"
                    @change="handleSliderChange"
                    :marks=[max,min]
                  >
                  </el-slider> -->
                </div>
              </div>
            </div>
          </div>
          <div class="middle-content" :style="styleObj1">
            <el-tabs v-model="secondActiveName" type="card" @tab-click="clickTableData">
              <el-tab-pane
                v-if="planConfig.listType && planConfig.listType.length > 1 && planConfig.listType.indexOf(1) > -1"
                :label="total['1'] !== 0 ? '专业/院校 ' + total['1'] : ' 专业/院校'" name="1">
                <div class="table-content">
                  <!--el-table。 表头（带排序）： 录取概率、 院校、2022年招生计划、招生计划增减、历年、2022年、2021年、2020年、填报-->
                  <div class="tzy-container">
                    <div class="h5-college-tr pl0 pb0" v-for="(item, index) in tableData" :key="index">
                      <div class="h5-major-tr flex" style="width: 100%">
                        <div class="percent">
                          <div class="probab">
                            <div class="probab-logo">
                              <img
                                src="data:image/png;base64,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"
                                alt="" />
                            </div>
                            <h1>
                              {{ item.probability }}
                              <span style="
                                  font-size: 10px;
                                  font-family: 'PingFang SC-Regular';
                                  margin-left: -5px;
                                ">%</span>
                            </h1>
                          </div>
                          <div class="tzy-chong-color three-frame">
                            {{ item.riskLevel }}
                          </div>
                          <p>{{ item.riskDesc }}</p>
                        </div>
                        <div class="major">
                          <div class="major-info">
                            <p class="h5-major-tr_title mb6">
                              <a href="javascript:void(0)" class="f16 mt5">
                                <el-tooltip effect="dark" :content="item.warnMsg[0]" placement="top"
                                  v-if="item.warnMsg && item.warnMsg.length > 0">
                                  <i class="el-icon-warning" color="#910000" style="
                                      font-size: 18px;
                                      color: #910000 !important;
                                      padding-right: 5px;
                                    ">
                                  </i>
                                </el-tooltip>
                                <span class="collegeNamePreview" style="word-break: break-all">{{ item.majorName
                                  }}</span>
                                <!--10.注释专业-->
                                <!-- <section class="zy-remark">
                                  {{ item.majorType }}
                                </section> -->
                                <p style="
                                    font-size: 12px;
                                    color: #9b9b9b;
                                    font-weight: normal;
                                  ">
                                  <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                                  <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                                </p>
                              </a>

                              <span v-if="item.canUse && item.canUse == 1">
                                <span class="profession-count-button" v-if="!isChecked(item.id)"
                                  @click="addCompareList(item)">填报
                                </span>
                                <span class="profession-count-button active" v-else @click="removeCompareList(item)">已填报
                                </span>
                              </span>

                              <el-tooltip class="item" placement="top" v-else>
                                <div slot="content">该专业选科受限制无法填报</div>
                                <i class="el-icon-s-release" style="font-size: 30px"> </i>
                              </el-tooltip>
                            </p>
                          </div>
                          <!---->
                          <p class="college-code">
                            <span class="pr10">
                              专业代码 {{ item.majorEnrollCode }}
                            </span>
                          </p>
                          <p class="college-code admissions">
                            <span>
                              <span class="mr10">
                                {{ item.year }}年计划 {{ item.planNum1 }}人
                              </span>
                              <span class="mr10" style="font-weight: normal">
                                {{ item.learnYear }} ¥{{ item.cost }}
                              </span>
                            </span>
                            <span class="mr10">
                              招生计划增减<span class="font">{{ item.planNumDiff > 0 ? "+" : ""
                                }}{{ item.planNumDiff }}</span>
                            </span>
                          </p>

                          <p class="mb6 college-code">
                            <span> 选科 {{ item.chooseSubject }} </span>
                          </p>
                          <div class="history-content history-conent">
                            <table>
                              <tr>
                                <th width="40">年份</th>
                                <th width="60">录取人数</th>
                                <th width="50">最低分</th>
                                <th>最低位次</th>
                                <!-- <th>平均分</th> -->
                              </tr>
                              <tr v-if="item.minScore1">
                                <td align="center">{{ item.year }}</td>
                                <td align="center">{{ item.planNum1 || "-" }}</td>
                                <td align="center">{{ item.minScore1 || "-" }}</td>
                                <td align="center">{{ item.minRank1 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage1 || "-" }}</td> -->
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 1 }}</td>
                                <td align="center">{{ item.planNum2 || "-" }}</td>
                                <td align="center">{{ item.minScore2 || "-" }}</td>
                                <td align="center">{{ item.minRank2 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage2 || "-" }}</td> -->
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 2 }}</td>
                                <td align="center">{{ item.planNum3 || "-" }}</td>
                                <td align="center">{{ item.minScore3 || "-" }}</td>
                                <td align="center">{{ item.minRank3 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage3 || "-" }}</td> -->
                              </tr>
                              <tr v-if="!(item.minScore1)">
                                <td align="center">{{ item.year - 3 }}</td>
                                <td align="center">{{ item.planNum4 || '-' }}</td>
                                <td align="center">{{ item.minScore4 || '-' }}</td>
                                <td align="center">{{ item.minRank4 || '-' }}</td>
                                <!-- <td align="center">{{ item.minAverage4 || "-" }}</td> -->
                              </tr>
                            </table>
                          </div>
                          <p class="mt5 mb4 fw500 majorNamePreview">
                            {{ item.collegeName }} {{ item.bzType }}
                          </p>
                          <p>
                            {{ item.features }}<br />
                            {{ item.province }} {{ item.city }} / {{ item.categories }} /
                            {{ item.natureType }}
                            <template v-if="item.collegeRank">
                              / 排名{{ item.collegeRank }}
                            </template>
                          </p>
                          <p v-if="item.masterRate && item.masterRate != ''">
                            保研率： {{ item.masterRate }}
                          </p>
                          <p class="college-code">
                            <span class="pr10">大学代码 {{ item.collegeEnrollCode }}</span>
                            <!-- 修改去掉-->
                            <!-- <span class="mr10"
                              >{{ item.year }}年计划 {{ item.planNum1 }}人</span
                            > -->
                          </p>
                        </div>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="planConfig.listType && planConfig.listType.indexOf(2) > -1"
                :label="total['2'] !== 0 ? '院校/专业 ' + total['2'] : '院校/专业'" name="2">
                <div class="table-content table3-child">
                  <!--el-table。 表头（带排序）： 录取概率、 院校、2022年招生计划、招生计划增减、历年、2022年、2021年、2020年、填报-->
                  <div class="tzy-container">
                    <div class="h5-college-tr pl0 pb0" v-for="(item, index) in tableData" :key="index">
                      <div class="h5-major-tr flex" style="width: 100%">
                        <div class="percent">
                          <div class="probab">
                            <div class="probab-logo">
                              <img
                                src="data:image/png;base64,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"
                                alt="" />
                            </div>
                            <h1>
                              {{ item.probability }}
                              <span style="
                                  font-size: 10px;
                                  font-family: 'PingFang SC-Regular';
                                  margin-left: -5px;
                                ">%</span>
                            </h1>
                          </div>
                          <div class="tzy-chong-color three-frame">
                            {{ item.riskLevel }}
                          </div>
                          <p>{{ item.riskDesc }}</p>
                        </div>
                        <div class="major">
                          <div class="major-info">
                            <p class="h5-major-tr_title mb6">
                              <a href="javascript:void(0)" class="f16 mt5"><span class="collegeNamePreview"
                                  style="word-break: break-all">{{ item.collegeName }}</span>
                                <!--10.注释专业-->
                                <!-- <section class="zy-remark">
                                  {{ item.majorType }}
                                </section> -->
                                <p style="
                                    font-size: 12px;
                                    color: #9b9b9b;
                                    font-weight: normal;
                                  ">
                                  <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                                  <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                                </p>
                              </a>
                              <span class="profession-count-button" @click="handleExpand(item)">
                                专业({{ item.majorNum }})
                              </span>
                            </p>
                          </div>
                          <!---->
                          <p class="mt5 mb4 fw500 majorNamePreview">
                            {{ item.features }} {{ item.bzType }}
                          </p>
                          <p>
                            {{ item.province }} {{ item.city }} / {{ item.categories }} /
                            {{ item.natureType }}
                            <template v-if="item.collegeRank">
                              / 排名{{ item.collegeRank }}
                            </template>
                          </p>
                          <p v-if="item.masterRate && item.masterRate != ''">
                            保研率： {{ item.masterRate }}
                          </p>
                          <div class="history-content history-conent">
                            <table>
                              <tr>
                                <th width="40">年份</th>
                                <th width="60">录取人数</th>
                                <th width="50">最低分</th>
                                <th>最低位次</th>
                                <!-- <th>平均分</th> -->
                              </tr>
                              <tr v-if="item.minScore1">
                                <td align="center">{{ item.year }}</td>
                                <td align="center">{{ item.planNum1 || "-" }}</td>
                                <td align="center">{{ item.minScore1 || "-" }}</td>
                                <td align="center">{{ item.minRank1 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage1 || "-" }}</td> -->
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 1 }}</td>
                                <td align="center">{{ item.planNum2 || "-" }}</td>
                                <td align="center">{{ item.minScore2 || "-" }}</td>
                                <td align="center">{{ item.minRank2 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage2 || "-" }}</td> -->
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 2 }}</td>
                                <td align="center">{{ item.planNum3 || "-" }}</td>
                                <td align="center">{{ item.minScore3 || "-" }}</td>
                                <td align="center">{{ item.minRank3 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage3 || "-" }}</td> -->
                              </tr>
                              <tr v-if="!(item.minScore1)">
                                <td align="center">{{ item.year - 3 }}</td>
                                <td align="center">{{ item.planNum4 || "-" }}</td>
                                <td align="center">{{ item.minScore4 || "-" }}</td>
                                <td align="center">{{ item.minRank4 || "-" }}</td>
                                <!-- <td align="center">{{ item.minAverage4 || "-" }}</td> -->
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="planConfig.listType && planConfig.listType.indexOf(3) > -1"
                :label="total['3'] !== 0 ? '院校/专业组 ' + total['3'] : '院校/专业组'" name="3">
                <div class="table-content table3-child">
                  <!--el-table。 表头（带排序）： 录取概率、 院校、2022年招生计划、招生计划增减、历年、2022年、2021年、2020年、填报-->
                  <div class="tzy-container">
                    <div class="h5-college-tr pl0 pb0" v-for="(item, index) in tableData" :key="index">
                      <div class="h5-major-tr flex" style="width: 100%">
                        <div class="percent">
                          <div class="probab">
                            <div class="probab-logo">
                              <img
                                src="data:image/png;base64,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"
                                alt="" />
                            </div>
                            <h1>
                              {{ item.probability }}
                              <span style="
                                  font-size: 10px;
                                  font-family: 'PingFang SC-Regular';
                                  margin-left: -5px;
                                ">%</span>
                            </h1>
                          </div>
                          <div class="tzy-chong-color three-frame">
                            {{ item.riskLevel }}
                          </div>
                          <p>{{ item.riskDesc }}</p>
                        </div>
                        <div class="major">
                          <div class="major-info">
                            <p class="h5-major-tr_title mb6">
                              <a href="javascript:void(0)" class="f16 mt5"><span class="collegeNamePreview"
                                  style="word-break: break-all">
                                  {{ item.collegeName }}({{ item.collegeMajorGroupName }})
                                </span>
                                <!--10.注释专业-->
                                <!-- <section class="zy-remark">
                                  {{ item.majorType }}
                                </section> -->
                                <!-- <p style="
                                    font-size: 14px;
                                    color: #000;
                                    font-weight: normal;
                                  ">
                                  ({{ item.city }} {{ item.collegeCode }})
                                </p> -->
                                <p style="
                                    font-size: 12px;
                                    color: #9b9b9b;
                                    font-weight: normal;display: none;
                                  ">
                                  <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                                  <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                                </p>
                              </a>
                              <span class="profession-count-button" @click="handleExpand(item)">
                                专业({{ item.majorNum }})
                              </span>
                            </p>
                          </div>
                          <!---->
                          <p class="mt5 mb4 fw500 majorNamePreview">
                            {{ item.features }}
                            <!-- {{ item.bzType }} -->
                          </p>
                          <p>
                            {{ item.province }} {{ item.city }} / {{ item.categories }} /
                            {{ item.natureType }}
                            <template v-if="item.collegeRank">
                              / 排名{{ item.collegeRank }}
                            </template>
                          </p>
                          <!-- <p>
                            选课： {{ item.chooseSubject||item.chooseSubject }}
                          </p> -->
                          <p class=" mb4">
                            <span class="mr10"> {{ item.year }}招生计划 {{ item.planNum1 }} 人</span>
                            <span v-if="item.masterRate && item.masterRate != ''">
                              保研率： {{ item.masterRate }}
                            </span>
                          </p>
                          <p class=" mb4">
                            <span class="mr10"> 招生计划增减 {{ item.planNumDiff > 0 ? "+" : "" }}{{
        item.planNumDiff
      }} 人</span>
                          </p>
                          <p>
                            <span style="font-weight: 0">
                              代码
                              <span style="font-size: 14px;color: #000;">
                                {{ item.collegeMajorGroupCode }}
                              </span>
                              <span style="padding-left:7px">
                                选科 {{ item.chooseSubject }}
                              </span>
                            </span>
                          </p>
                          <div class="history-content history-conent mt5">
                            <table>
                              <tr>
                                <th width="40">年份</th>
                                <th width="60">录取人数</th>
                                <th width="50">最低分</th>
                                <th>最低位次</th>
                              </tr>
                              <tr v-if="item.minScore1">
                                <td align="center">{{ item.year }}</td>
                                <td align="center">{{ item.planNum1 || "-" }}</td>
                                <td align="center">{{ item.minScore1 || "-" }}</td>
                                <td align="center">{{ item.minRank1 || "-" }}</td>
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 1 }}</td>
                                <td align="center">{{ item.planNum2 || "-" }}</td>
                                <td align="center">{{ item.minScore2 || "-" }}</td>
                                <td align="center">{{ item.minRank2 || "-" }}</td>
                              </tr>
                              <tr>
                                <td align="center">{{ item.year - 2 }}</td>
                                <td align="center">{{ item.planNum3 || "-" }}</td>
                                <td align="center">{{ item.minScore3 || "-" }}</td>
                                <td align="center">{{ item.minRank3 || "-" }}</td>
                              </tr>
                              <tr v-if="!(item.minScore1)">
                                <td align="center">{{ item.year - 3 }}</td>
                                <td align="center">{{ item.planNum4 || '-' }}</td>
                                <td align="center">{{ item.minScore4 || '-' }}</td>
                                <td align="center">{{ item.minRank4 || '-' }}</td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <div style="font-size: 16px; padding: 20px 30px; font-weight: 700" v-if="tableData.length == 0">
                该分数段内暂无数据，可以尝试调整筛选条件
              </div>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="foot-box van-row">
      <div class="foot-box-a">
        <a href="javascript:void(0)" class="text-center f14 color-666" style="flex: 1 1 0%">
          已填<span class="filled">{{ (planConfig.listType && planConfig.listType.indexOf(3) > -1) ? compareCollegeInfo &&
        compareCollegeInfo.length : compareCollegeList.length }}</span>个
        </a>
      </div>
      <div class="recommendBtn-flex-flex">
        <button @click="clickCompare" class="recommend-btn van-button van-button--primary van-button--large">
          <div class="van-button__content">
            <span class="van-button__text">预览志愿表</span>
          </div>
        </button>
      </div>
    </div>
    <!--开通VIP即可体验-->
    <van-popup v-model="vipDialogVisible" closeable close-icon-position="top-right" position="center"
      :style="{ height: '300px', width: '90vw', borderRadius: '10px' }">
      <div class="f-col" style="align-items: center; padding-top: 60px">
        <img style="width: 80px"
          src="data:image/png;base64,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"
          alt="" />
        <p class="m-t-20 fz-16 center" style="color: #333">开通VIP即可体验</p>
        <el-button style="" type="primary" class="m-t-20" @click="openVip">开通VIP</el-button>
      </div>
    </van-popup>
    <!--创建成绩-->
    <el-dialog title="创建成绩" :visible.sync="dialogVisible" width="500px" :before-close="closeDialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="tips-box">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px"
          v-if="scoreOption[currentProvinceInfo.type]">
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course1.name" prop="course1"
            v-if="scoreOption[currentProvinceInfo.type].course1">
            <el-checkbox-group v-model="form['course1']" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course1.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course1.tags" :label="tag" :key="tag">
                {{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course2.name" prop="course2"
            v-if="scoreOption[currentProvinceInfo.type].course2">
            <el-checkbox-group v-model="form['course2']" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course2.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course2.tags" :label="tag" :key="tag">
                {{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="成绩" :prop="scoreName == 'first' ? 'predict_score' : 'real_score'">
            <el-tabs v-model="scoreName" type="card">
              <el-tab-pane label="估分分数" name="first">
                <el-input v-model.number="form.predict_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
              </el-tab-pane>
              <el-tab-pane label="高考分数" name="second">
                <el-input v-model.number="form.real_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
                <el-input v-model.number="form.read_rank" style="margin-top: 10px">
                  <template slot="append">位次</template>
                </el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
            <el-button v-if="score != ''" @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--志愿表预览-->
    <van-popup v-model="compareShow" closeable close-icon-position="top-right" position="bottom"
      :style="{ height: '80vh', borderRadius: '10px 10px 0 0' }">
      <div class="compare-list">
        <div class="compare-list-title">志愿表预览</div>
        <div class="compare-list-content">
          <template v-if="planConfig.listType && planConfig.listType.length == 1">
            <div class="compare-list-item" v-for="(val, index) in compareCollegeInfo" :key="index">
              <div class="compare-list-item-header">
                <span class="index">{{ index + 1 }}</span>
              </div>
              <div class="compare-list-item-cont">
                <h1 class="bf">
                  {{ val.probability }}
                  <span class="fb"> %</span>
                </h1>
                <div class="cont-text">
                  <!-- <div class="cont-text-name">{{ val[0].collegeName }}</div> -->
                  <!-- <p class="zy-remark">{{ val[0].majorName }}</p> -->
                  <div class="cont-text-name">
                    {{ val.collegeName }}
                    <span v-if="val.collegeMajorGroupName">
                      ({{ val.collegeMajorGroupName }})
                    </span>
                  </div>
                  <!--10.注释专业-->
                  <!-- <p class="zy-remark">{{ val[0].majorType }}</p> -->
                  <!-- <div class="cont-text-name pad_top">
                    {{ val.collegeName }}
                  </div> -->
                  <p class="zy-remark">
                    <!-- ({{ val.bzType }}) -->
                    ({{ val.province }},{{ val.natureType }})
                  </p>
                </div>
                <div class="del">
                  <i class="el-icon-delete" @click="removeCompare(val.removeCode, 'all')"></i>
                </div>
              </div>
              <!-- /compare-list-item-cont-->
              <div class="compare-list-item-cont" v-for="(v, i) in val.majors" :key="i">
                <!-- <h1 class="bf"></h1> -->
                <h1 class="bf">
                  <!-- {{ v.probability }}
                  <span class="fb">%</span> -->
                </h1>
                <div class="cont-text">
                  <div class="cont-text-name" style="font-size: 16px;">{{ i + 1 }}、{{ v.majorName }}</div>
                  <!-- <p class="zy-remark">{{ val[0].majorName }}</p> -->
                </div>
                <div class="del">
                  <i class="el-icon-delete" @click="removeCompare(v)"></i>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="compare-list-item" v-for="(item, index) in compareCollegeList" :key="index">
              <div class="compare-list-item-header">
                <span class="index">{{ index + 1 }}</span>
              </div>
              <div class="compare-list-item-cont">
                <h1 class="bf">
                  {{ item.probability }}
                  <span class="fb">%</span>
                </h1>
                <div class="cont-text">
                  <div class="cont-text-name">{{ item.majorName }}</div>
                  <!-- <p class="zy-remark">{{ item.majorType }}</p> -->
                  <p style="font-size: 12px; color: #9b9b9b; font-weight: normal">
                    <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                    <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                  </p>
                  <div class="cont-text-name pad_top">{{ item.collegeName }}</div>
                  <p class="zy-remark">
                    <!-- ({{ item.bzType }}) -->
                    ({{ item.province }},{{ item.natureType }})
                  </p>
                </div>
                <div class="del">
                  <i class="el-icon-delete" @click="removeCompare(item)"></i>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="recommend-save">
        <button @click="savePlan" class="saveBtn">
          <div class="van-button__content">
            <span class="van-button__text">保存志愿表</span>
            <span>
              (已填{{ (planConfig.listType && planConfig.listType.indexOf(3) > -1) ? compareCollegeInfo &&
        compareCollegeInfo.length : compareCollegeList.length }}个志愿)
            </span>
          </div>
        </button>
      </div>
    </van-popup>
    <!--专业子集-->
    <van-popup v-model="majorDataShow" closeable close-icon-position="top-right" position="bottom"
      :style="{ height: '80vh', borderRadius: '10px 10px 0 0' }">
      <div class="major_title">
        <div class="title1">
          {{ majorData && majorData.collegeName }}
          <span v-if="majorData && majorData.collegeMajorGroupName">
            ({{ majorData && majorData.collegeMajorGroupName }})
          </span>
        </div>
        <p class="title2">
          <!-- ({{ majorData && majorData.bzType }})  -->
          ({{ majorData && majorData.province }},{{
        majorData && majorData.natureType
      }})
        </p>
        <!-- <p class="title3">
         已填 {{ compareCollegeInfo }}
        </p> -->
      </div>

      <div class="major_cont">
        <!--专业组-->
        <div class="tzy-container" v-if="planConfig.listType && planConfig.listType.indexOf(3) > -1">
          <div class="h5-college-tr pl0 pb0" v-for="(item, index) in tableChildrenData" :key="index">
            <div class="h5-major-tr flex" style="width: 100%">
              <div class="percent">
                <div class="probab">
                  <div class="probab-logo">
                    <img
                      src="data:image/png;base64,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"
                      alt="" />
                  </div>
                  <h1>
                    {{ item.probability }}
                    <span style="
                        font-size: 10px;
                        font-family: 'PingFang SC-Regular';
                        margin-left: -5px;
                      ">%</span>
                  </h1>
                </div>
                <div class="tzy-chong-color three-frame">
                  {{ item.riskLevel }}
                </div>
                <p>{{ item.riskDesc }}</p>
              </div>
              <div class="major">
                <div class="major-info">
                  <p class="h5-major-tr_title mb6">
                    <a href="javascript:void(0)" class="f16 mt5">
                      <el-tooltip effect="dark" :content="item.warnMsg[0]" placement="top"
                        v-if="item.warnMsg && item.warnMsg.length > 0">
                        <i class="el-icon-warning" color="#910000" style="
                            font-size: 18px;
                            color: #910000 !important;
                            padding-right: 5px;
                          ">
                        </i>
                      </el-tooltip>
                      <span class="collegeNamePreview" style="word-break: break-all">
                        {{ item.majorName }}
                      </span>
                      <!--10.注释专业-->
                      <!-- <section class="zy-remark">
                        {{ item.majorType }}
                      </section> -->
                      <p style="font-size: 12px; color: #9b9b9b; font-weight: normal;">
                        <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                        <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                      </p>
                      <!-- <p style="font-size: 14px;color: #000;font-weight: normal;">
                        ({{ item.city }} {{ item.collegeCode }})
                      </p> -->
                    </a>

                    <span v-if="item.canUse && item.canUse == 1">
                      <span class="profession-count-button" v-if="!isChecked(item.id)" @click="addCompareList(item)">填报
                      </span>
                      <span class="profession-count-button active" v-else @click="removeCompareList(item)">已填报
                      </span>
                    </span>
                    <el-tooltip class="item" placement="top" v-else>
                      <div slot="content">该专业选科受限制无法填报</div>
                      <i class="el-icon-s-release" style="font-size: 30px"> </i>
                    </el-tooltip>
                  </p>
                </div>
                <!---->
                <p class=" college-code">
                  <span class="pr10"> 专业代码 {{ item.majorEnrollCode }} </span><br />
                  <span class="mr10"> {{ item.year }}年计划 {{ item.planNum1 }}人 </span>
                  <span style="font-weight: normal">
                    {{ item.learnYear }} ¥{{ item.cost }}
                    <span class="ml10">
                      招生计划增减<span class="pl6">{{ item.planNumDiff > 0 ? "+" : "" }}{{ item.planNumDiff
                        }}</span>
                    </span>
                    <br />
                    选科 {{ item.chooseSubject }}
                  </span>
                </p>
                <!-- <p class="mb6 college-code" v-if="item.masterRate && item.masterRate != ''">
                  保研率： {{ item.masterRate }}</p> -->
                <!-- <p>
                  <span style="font-weight: 0">
                    代码
                    <span style="font-size: 14px;color: #000;">
                      {{ item.collegeMajorGroupCode }}
                    </span>
                  </span>
                </p> -->
                <div class="history-content history-conent">
                  <table>
                    <tr>
                      <th width="40">年份</th>
                      <th width="60">录取人数</th>
                      <th width="50">最低分</th>
                      <th width="60">最低位次</th>
                      <th>平均分</th>
                    </tr>
                    <tr v-if="item.minScore1">
                      <td align="center">{{ item.year }}</td>
                      <td align="center">{{ item.planNum1 }}</td>
                      <td align="center">{{ item.minScore1 }}</td>
                      <td align="center">{{ item.minRank1 }}</td>
                      <td align="center">{{ item.minAverag1 || "-" }}</td>
                    </tr>
                    <tr>
                      <td align="center">{{ item.year - 1 }}</td>
                      <td align="center">{{ item.planNum2 || "-" }}</td>
                      <td align="center">{{ item.minScore2 || "-" }}</td>
                      <td align="center">{{ item.minRank2 || "-" }}</td>
                      <td align="center">{{ item.minAverag2 || "-" }}</td>
                    </tr>
                    <tr>
                      <td align="center">{{ item.year - 2 }}</td>
                      <td align="center">{{ item.planNum3 || "-" }}</td>
                      <td align="center">{{ item.minScore3 || "-" }}</td>
                      <td align="center">{{ item.minRank3 || "-" }}</td>
                      <td align="center">{{ item.minAverag3 || "-" }}</td>
                    </tr>
                    <tr v-if="!(item.minScore1)">
                      <td align="center">{{ item.year - 3 }}</td>
                      <td align="center">{{ item.planNum4 || '-' }}</td>
                      <td align="center">{{ item.minScore4 || '-' }}</td>
                      <td align="center">{{ item.minRank4 || '-' }}</td>
                      <td align="center">{{ item.minAverag4 || "-" }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!---->
          </div>
        </div>
        <!--专业-->
        <div class="tzy-container" v-else>
          <div class="h5-college-tr pl0 pb0" v-for="(item, index) in tableChildrenData" :key="index">
            <div class="h5-major-tr flex" style="width: 100%">
              <div class="percent">
                <div class="probab">
                  <div class="probab-logo">
                    <img
                      src="data:image/png;base64,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"
                      alt="" />
                  </div>
                  <h1>
                    {{ item.probability }}
                    <span style="
                        font-size: 10px;
                        font-family: 'PingFang SC-Regular';
                        margin-left: -5px;
                      ">%</span>
                  </h1>
                </div>
                <div class="tzy-chong-color three-frame">
                  {{ item.riskLevel }}
                </div>
                <p>{{ item.riskDesc }}</p>
              </div>
              <div class="major">
                <div class="major-info">
                  <p class="h5-major-tr_title mb6">
                    <a href="javascript:void(0)" class="f16 mt5">
                      <el-tooltip effect="dark" :content="item.warnMsg[0]" placement="top"
                        v-if="item.warnMsg && item.warnMsg.length > 0">
                        <i class="el-icon-warning" color="#910000" style="
                            font-size: 18px;
                            color: #910000 !important;
                            padding-right: 5px;
                          ">
                        </i>
                      </el-tooltip>
                      <span class="collegeNamePreview" style="word-break: break-all">
                        {{ item.majorName }}
                      </span>
                      <!--10.注释专业-->
                      <!-- <section class="zy-remark">
                        {{ item.majorType }}
                      </section> -->
                      <p style="font-size: 12px; color: #9b9b9b; font-weight: normal">
                        <span v-if="item.subjectReview">学科评估 {{ item.subjectReview }}</span>
                        <span v-if="item.majorLevel">专业水平 {{ item.majorLevel }}</span>
                      </p>
                    </a>
                    <span v-if="item.canUse && item.canUse == 1">
                      <span class="profession-count-button" v-if="!isChecked(item.id)" @click="addCompareList(item)">填报
                      </span>
                      <span class="profession-count-button active" v-else @click="removeCompareList(item)">已填报
                      </span>
                    </span>
                    <el-tooltip class="item" placement="top" v-else>
                      <div slot="content">该专业选科受限制无法填报</div>
                      <i class="el-icon-s-release" style="font-size: 30px"> </i>
                    </el-tooltip>
                  </p>
                </div>
                <!---->
                <p class="mb6 college-code">
                  <span class="pr10"> 专业代码 {{ item.majorEnrollCode }} </span><br />
                  <span class="mr10"> {{ item.year }}年计划 {{ item.planNum1 }}人 </span>
                  <span style="font-weight: normal">
                    {{ item.learnYear }} ¥{{ item.cost }}
                    <span class="ml10">
                      招生计划增减<span class="pl6">{{ item.planNumDiff > 0 ? "+" : "" }}{{ item.planNumDiff }}</span>
                    </span>
                    <br />
                    选科 {{ item.chooseSubject }}
                  </span>
                </p>
                <div class="history-content history-conent">
                  <table>
                    <tr>
                      <th width="40">年份</th>
                      <th width="60">录取人数</th>
                      <th width="50">最低分</th>
                      <th>最低位次</th>
                      <!-- <th>平均分</th> -->
                    </tr>
                    <tr v-if="item.minScore1">
                      <td align="center">{{ item.year }}</td>
                      <td align="center">{{ item.planNum1 }}</td>
                      <td align="center">{{ item.minScore1 }}</td>
                      <td align="center">{{ item.minRank1 }}</td>
                      <!-- <td align="center">{{ item.minAverag1 || "-" }}</td> -->
                    </tr>
                    <tr>
                      <td align="center">{{ item.year - 1 }}</td>
                      <td align="center">{{ item.planNum2 || "-" }}</td>
                      <td align="center">{{ item.minScore2 || "-" }}</td>
                      <td align="center">{{ item.minRank2 || "-" }}</td>
                      <!-- <td align="center">{{ item.minAverag2 || "-" }}</td> -->
                    </tr>
                    <tr>
                      <td align="center">{{ item.year - 2 }}</td>
                      <td align="center">{{ item.planNum3 || "-" }}</td>
                      <td align="center">{{ item.minScore3 || "-" }}</td>
                      <td align="center">{{ item.minRank3 || "-" }}</td>
                      <!-- <td align="center">{{ item.minAverag2 || "-" }}</td> -->
                    </tr>
                    <tr v-if="!(item.minScore1)">
                      <td align="center">{{ item.year - 3 }}</td>
                      <td align="center">{{ item.planNum4 || '-' }}</td>
                      <td align="center">{{ item.minScore4 || '-' }}</td>
                      <td align="center">{{ item.minRank4 || '-' }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!---->
          </div>
        </div>
      </div>
    </van-popup>
    <card-bind :showModal="showModal" @closeModal="showModal = false" :routePath="''" :vipType="2"
      :reload="true"></card-bind>
    <div class="backTop" @click="toTop" v-if="topShow">
      <img src="../../assets/image/top.png" alt="" />
    </div>
  </div>
</template>

<script>
import { getParams, getNavData } from "@/utils";
import { mapState } from "vuex";
import VueSlider from "vue-slider-component";
import cardBind from "@/components/cardBind";

export default {
  components: {
    VueSlider,
    cardBind,
  },
  data() {
    return {
      bgImg: require("../../assets/image/img_bg.png"),
      dialogVisible: false,
      vipDialogVisible: false,
      showModal: false,
      activeName: "college", //'college',
      secondActiveName: "1",
      planConfig: {},
      filterOption: {},
      filterData: {
        provinces: [],
        features: [],
        categories: [],
        newCollege: [],
        school: [],
        keyword: "",
        sortKey: "",
        sortOrder: "",
      },
      majorFilterOption: {
        features: [
          {
            name: "本科",
            value: "本科",
            isChecked: true,
          },
          {
            name: "专科",
            value: "专科",
            isChecked: false,
          },
        ],
        majorList: {
          name: "专业类别",
          type: "majorList",
          list: [],
        },
        // newMajor: {
        //     name: '新增专业',
        //     type: 'newMajor',
        //     list: [{
        //         name:'非新增专业',
        //         value: '0',
        //         isChecked: false
        //     },{
        //         name:'新增专业',
        //         value: '1',
        //         isChecked: false
        //     }]
        // },
        majorType: {
          name: "高级筛选",
          list: [
            {
              name: "普通类",
              value: "普通类",
            },
            {
              name: "专项",
              value: "专项",
            },
            {
              name: "师范类",
              value: "师范类",
            },
            // {
            //   name: "扶贫",
            //   value: "扶贫",
            // },
            {
              name: "含学科评估",
              value: "含学科评估",
            },
            {
              name: "预科",
              value: "预科",
            },
            {
              name: "定向",
              value: "定向",
            },
            {
              name: "少数民族",
              value: "少数民族",
            },
            {
              name: "色盲色弱",
              value: "色盲色弱",
            },
            {
              name: "非新增专业",
              value: "0",
            },
            {
              name: "新增专业",
              value: "1",
            },
          ],
        },
        cost: {
          name: "学费级别",
          type: "cost",
          list: [],
        },
      },
      majorFilterData: {
        features: ["本科"],
        majorList: [],
        majorType: [],
        newMajor: [],
        cost: [],
        keyword: "",
      },
      jobFilterOption: {
        jobList: {
          name: "职业选择",
          type: "jobList",
          list: [],
        },
      },
      jobFilterData: {
        jobList: [],
        keyword: "",
        keywordInfo: {},
        sortKey: "",
        sortOrder: "",
      },
      arr_ben: [],
      arr_zhuan: [],
      loading: false,
      tableData: [], // 表格数据
      tableChildrenData: [], // 表格子数据
      sliderValue: [0, 0],
      total: {
        1: 0,
        2: 0,
        3: 0,
      },
      page: 1,
      compareShow: false,
      compareCollegeList: [],
      // compareCollegeInfo: {},
      checkedColleges: [],
      majorTestList: [],
      chooseSubject: [],
      chooseSubjectData: [],
      userEvaluation: [],
      score: 0,
      course: "",
      scoreOption: {},
      scoreName: "",
      // rules  第一项判断scoreOption[currentProvinceInfo.type].course1是否存在，存在label为scoreOption[currentProvinceInfo.type].course1.name，check-box为scoreOption[currentProvinceInfo.type].course1.tags，必填项为scoreOption[currentProvinceInfo.type].course1.must，第二项判断scoreOption[currentProvinceInfo.type].course1是否存在，存在label为scoreOption[currentProvinceInfo.type].course1.name，第三项分数分为两个tab 1、估分分数 2、高考分数。 区间为100-750。必填一个
      rules: {
        course1: [{ required: true, message: "请选择" }],
        course2: [{ required: true, message: "请选择" }],
        real_score: [
          { required: true, message: "请输入高考分数", trigger: "blur" },
          { type: "number", message: "高考分数为数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value < 100 || value > 750) {
                callback(new Error("请输入100-750之间的数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        predict_score: [
          { required: true, message: "请输入估分分数", trigger: "blur" },
          { type: "number", message: "估分分数为数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value < 100 || value > 750) {
                callback(new Error("请输入100-750之间的数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      form: {
        course1: [],
        course2: [],
        type: "1",
        real_score: "",
        read_rank: "",
        predict_score: "",
      },
      gridData: [],
      limit: {
        max: 0,
        now: 0,
      },
      vipList: {},
      isDisabled_course1: false,
      isDisabled_course2: false,
      scoreInfo: {},
      scoreHistory: null,
      navData: null,
      majorDataShow: false,
      majorData: null,
      //zhua
      activeMajorKey: 0,
      activeJobKey: 0,
      searchData: {
        college: "",
        major: "",
        job: "",
      },
      topShow: false,
      isShowMore: false,
      yearsCheckList: {
        year: "",
        num: 0,
      },
      soreType: 0, //招生计划增减
      styleObj: {
        position: "",
        top: "50px",
        zIndex: 99,
        borderTop: "",
        borderBottom: "",
        paddingTop: "",
      },
      styleObj1: {
        paddingTop: "",
      },
      timeTop: null,
      oldScrollTop: 0,
      routerData: "",
      __loading: false,
    };
  },
  // 计算属性
  computed: {
    //新的筛选条件
    newFilterDataArr() {
      this.page = 1;
      this.tableData = [];
      let arr = [];
      for (let key in this.filterData) {
        if (
          key === "provinces" ||
          key === "features" ||
          key === "categories" ||
          key === "newCollege" ||
          key === "cost" ||
          key === "school"
        ) {
          arr = arr.concat(this.filterData[key]);
        }
      }
      for (let key in this.majorFilterData) {
        if (
          key === "majorList" ||
          key === "majorType" ||
          key === "newMajor" ||
          key === "cost"
        ) {
          arr = arr.concat(this.majorFilterData[key]);
        }
      }
      arr = arr.concat(
        this.userEvaluation.map((e) => {
          return { name: e, value: e, type: "userEvaluation" };
        })
      );
      arr = arr.concat(
        this.chooseSubjectData.map((e) => {
          return { name: e, value: e, type: "chooseSubject" };
        })
      );
      for (let key in this.jobFilterData) {
        if (key === "jobList") {
          arr = arr.concat(this.jobFilterData[key]);
        }
      }
      return arr;
    },
    // 动态计算 filterData中的数据(除了keyword)合并成一个数组
    filterDataArr() {
      let arr = [];
      for (let key in this.filterData) {
        if (
          key === "provinces" ||
          key === "features" ||
          key === "categories" ||
          key === "newCollege" ||
          key === "school"
        ) {
          arr = arr.concat(this.filterData[key]);
        }
      }
      return arr;
    },
    // 动态计算 majorFilterData中的数据(除了keyword)合并成一个数组
    majorFilterDataArr() {
      let arr = [];
      for (let key in this.majorFilterData) {
        if (
          key === "majorList" ||
          key === "majorType" ||
          key === "newMajor" ||
          key === "cost"
        ) {
          arr = arr.concat(this.majorFilterData[key]);
        }
      }
      arr = arr.concat(
        this.userEvaluation.map((e) => {
          return { name: e, value: e, type: "userEvaluation" };
        })
      );
      return arr;
    },
    jobFilterDataArr() {
      let arr = [];
      for (let key in this.jobFilterData) {
        if (key === "jobList") {
          arr = arr.concat(this.jobFilterData[key]);
        }
      }
      return arr;
    },

    compareCollegeInfo() {
      //     遍历this.compareCollegeList；相同的collegeCode放到一个数组中
      // let obj = {};
      // console.log(this.compareCollegeList);
      // this.compareCollegeList.forEach((item) => {
      //   if (!obj[item.collegeCode]) {
      //     obj[item.collegeCode] = [item];
      //   } else {
      //     obj[item.collegeCode].push(item);
      //   }
      // });
      // console.log(obj);
      // return obj;
      let arr = []
      this.compareCollegeList.forEach((item, index) => {
        if (this.planConfig.listType.length === 1 && this.planConfig.listType[0] == 3) {

          let _index = arr.findIndex((ele) => { return ele.collegeMajorGroupCode == item.collegeMajorGroupCode })
          console.log(5554444, _index);
          if (_index > -1) {
            arr[_index].majors.push(item)
          } else {
            console.log(7777);
            let _obj = Object.assign({}, item)
            _obj.majors = [item]
            _obj.removeCode = item.collegeMajorGroupCode
            arr.push(_obj)
          }
        } else {
          let _index = arr.findIndex((ele) => { return ele.collegeCode == item.collegeCode })
          if (_index > -1) {
            arr[_index].majors.push(item)
          } else {
            let _obj = Object.assign({}, item)
            _obj.majors = [item]
            _obj.removeCode = item.collegeCode
            arr.push(_obj)
          }
        }

      })

      console.log(5555, arr);
      return arr
    },
    majorList() {
      if (this.majorFilterData.features.includes("本科")) {
        return {
          name: "专业选择",
          type: "majorList",
          list: this.arr_ben.map((e) => {
            e.isChecked = false;
            return e;
          }),
        };
      } else {
        return {
          name: "专业选择",
          type: "majorList",
          list: this.arr_zhuan.map((e) => {
            e.isChecked = false;
            return e;
          }),
        };
      }
    },
    ...mapState({
      currentProvinceInfo: (state) => state.currentProvinceInfo,
    }),
    noMore() {
      return this.tableData.length >= this.total[this.secondActiveName];
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  watch: {
    scoreOption(val) {
      if (
        val[this.currentProvinceInfo.type]?.course1 &&
        val[this.currentProvinceInfo.type]?.course1.length > 0
      ) {
        this.rules.course1 = [
          {
            required: true,
            message: `请选择${val[this.currentProvinceInfo.type]?.course1.must}个${val[this.currentProvinceInfo.type]?.course1.name
              }`,
          },
        ];
      } else {
        this.rules.course1 = [];
      }
      if (
        val[this.currentProvinceInfo.type]?.course2 &&
        val[this.currentProvinceInfo.type]?.course2.length > 0
      ) {
        this.rules.course2 = [
          {
            required: true,
            message: `请选择${val[this.currentProvinceInfo.type]?.course2.must}个${val[this.currentProvinceInfo.type]?.course2.name
              }`,
          },
        ];
      } else {
        this.rules.course2 = [];
      }
    },
    scoreName(val) {
      if (val == "first") {
        this.form.real_score = "";
        this.form.type = "1";
      } else {
        this.form.predict_score = "";
        this.form.type = "2";
      }
    },
  },
  async mounted() {
    const vipList = await this.$axios.get("/php/user.info");
    this.vipList = vipList.data.data.vipList;
    this.isShowMore = this.vipList[2];
    await this.getUserInfo();
    let scoreOption = await this.$axios.get("/php/score.config.get");
    this.scoreOption = scoreOption.data;
    this.scoreName = "first";
    await this.getGridData();
    await this.getPlanConfig();
    await this.getFilterOption();
    await this.getTableData();
    await this.getMajorTestList();
    window.addEventListener("scroll", this.windowScroll);
    await this.getScoreHistory();
    const { query } = this.$router.currentRoute;
    this.routerData = query;
    console.log("====111", query);
    // let data=JSON.parse(localStorage.getItem('savePlan'))

    if (query.editId) {
      // this.userPlanlist(query.editId);
      this.compareCollegeList = this.$store.state.editPlan;
      console.log("=====修改编辑", this.$store.state.editPlan);
    }
    // this.getMajorFilterOption();
    // this.getJobFilterOption();
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
  },
  methods: {
    toTop() {
      // document.documentElement.scrollTop = 0;
      // var scrollTop = this.getScrollTop();
      // var clientHeight = this.getClientHeight();
      // var scrollHeight = this.getScrollHeight();

      this.timeTop = setInterval(() => {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // 实现滚动效果
        let speed = scrollTop / 20; // 每次滚动多少 （步长值）
        console.log("scrollTop", scrollTop);
        if (scrollTop) {
          document.documentElement.scrollTop -= speed; // 不在顶部 每次滚动到的位置
          document.body.scrollTop -= speed;
        } else {
          clearInterval(this.timeTop); // 回到顶部清除定时器
        }
      }, 50);
    },
    //数据详情
    async userPlanlist(editId) {
      const res = await this.$axios.get(`/php/user.plan.detail?id=${editId}`);
      console.log(res.data.data);
      this.compareCollegeList = res.data.data.planList;

      // this.$nextTick(() => {
      //   this.rowDrop();
      // });
    },
    async getScoreHistory() {
      const apiUrl = "/php/user.score.get"; //'php/score.config.get';
      const res = await this.$axios.get(apiUrl);
      if (res.data.ret === 0) {
        this.scoreHistory = res.data.data;
        this.navData = getNavData(this.scoreHistory.score);
        // this.sclole = res.data.data.score?.predict_score?res.data.data.score.predict_score:this.real_scoreStart;
        console.log("===navData", this.navData, "====scoreHistory", this.scoreHistory);
      }
    },
    async getGridData() {
      const list = await this.$axios.get("/php/pici.list");
      this.gridData = list.data.data.list;
    },
    async getUserInfo() {
      const score = await this.$axios.get("/php/user.score.get");
      if (!score.data.data.score) {
        this.dialogVisible = true;
        return false;
      } else {
        this.score = score.data.data.score.score1;
        this.course = score.data.data.score.course;
        this.limit = score.data.data.limit;
      }
    },
    async getMajorTestList() {
      const res = await this.$axios.get("/php/user.test.major.get");
      this.majorTestList = res.data.data.map((e) => {
        return {
          label: e,
          value: e,
        };
      });
    },
    // 获取志愿配置信息
    async getPlanConfig() {
      const res = await this.$axios.get(
        "/php/plan.config.get?pcId=" + this.$route.query.id
      );
      this.planConfig = res.data.data;
      // this.planConfig.listType = [1,2]
      // this.planConfig.course = ['物理','生物','化学']
      if (this.planConfig.listType.length === 1) {
        if (this.planConfig.listType[0] == 2) {
          this.secondActiveName = '2'
        } else if (this.planConfig.listType[0] == 3) {
          this.secondActiveName = '3'
        }
      }
      this.sliderValue = [this.planConfig.middleMinScore, this.planConfig.middleMaxScore];
      this.majorFilterOption.cost.list = this.planConfig.cost;
    },
    // 获取院校筛选配置
    async getFilterOption() {
      const res = await this.$axios.get("/php/college.list.config");
      res.data.data.map((e, i) => {
        switch (i) {
          case 0:
            e.type = "provinces";
            break;
          case 1:
            e.type = "categories";
            break;
          case 2:
            e.type = "features";
            e.list = e.list.concat([
              { name: "新增院校", value: 1 },
              { name: "非新增院校", value: 0 },
            ]);
            console.log(e.list);
            break;
        }
        e.list.map((a) => {
          a.isChecked = false;
          return a;
        });
        return e;
      });
      this.filterOption = res.data.data;
    },
    //选课是否有限制
    handleChooseSubject(item) {
      // console.log(
      //   this.scoreHistory.score.course,
      //   this.scoreHistory.score.course.indexOf(item.chooseSubject) > -1,
      //   "选课是否有限制",
      //   item.majorName,
      //   item.chooseSubject
      // );

      let show = true;
      if (item.chooseSubject == "无限制" || item.chooseSubject == "不限" || item.chooseSubject == "") {
        show = false;
      } else {
        // if (this.scoreHistory.score.course.indexOf(item.chooseSubject) > -1) {
        //   show = false;
        // } else
        if (
          this.scoreHistory &&
          this.scoreHistory.score.course == "理科" &&
          handleScience(item)
        ) {
          show = false;
        } else if (
          this.scoreHistory &&
          this.scoreHistory.score.course == "文科" &&
          handleLiberal(item)
        ) {
          show = false;
        } else {
          let sub = "";
          if (item.chooseSubject.indexOf("或") > -1) {
            sub = item.chooseSubject.replace("或", ",");
            let arr = sub.split(",");
            for (let i = 0; i < arr.length; i++) {
              if (
                this.scoreHistory &&
                this.scoreHistory.score.course.indexOf(arr[i]) > -1
              ) {
                show = false;
                break;
              }
            }
          } else if (item.chooseSubject.indexOf("与") > -1) {
            sub = item.chooseSubject.replace("与", ",");
            if (this.scoreHistory && this.scoreHistory.score.course.indexOf(sub) > -1) {
              show = false;
            }
          } else {
            sub = item.chooseSubject;
            if (this.scoreHistory && this.scoreHistory.score.course.indexOf(sub) > -1) {
              show = false;
            }
          }
        }
      }
      return show;
    },
    handleScience(item) {
      let science = true;
      if (item.chooseSubject.indexOf("物") > -1) {
        return (science = true);
      } else if (item.chooseSubject.indexOf("化") > -1) {
        return (science = true);
      } else if (item.chooseSubject.indexOf("生") > -1) {
        return (science = true);
      } else {
        return (science = false);
      }
    },
    handleLiberal(item) {
      let liberal = true;
      if (item.chooseSubject.indexOf("政") > -1) {
        return (liberal = true);
      } else if (item.chooseSubject.indexOf("历") > -1) {
        return (liberal = true);
      } else if (item.chooseSubject.indexOf("地") > -1) {
        return (liberal = true);
      } else {
        return (liberal = false);
      }
    },
    // 获取专业筛选配置
    async getMajorFilterOption() {
      const res = await this.$axios.get("/php/major.list");
      // res.data.data.map((e, i) => {
      //     e.list.map(a => {
      //         a.isChecked = false
      //         return a
      //     })
      //     return e
      // })
      // res.data.data过滤掉一层，取出二层数据
      this.arr_ben = [];
      res.data.data.ben.forEach((item) => {
        this.arr_ben = this.arr_ben.concat(item.major);
      });
      console.log(this.arr_ben);
      this.arr_zhuan = [];
      res.data.data.zhuan.forEach((item) => {
        this.arr_zhuan = this.arr_zhuan.concat(item.major);
      });
      this.arr_ben = this.arr_ben.map((e) => {
        e.isChoose = false;
        return e;
      });
      this.arr_zhuan = this.arr_zhuan.map((e) => {
        e.isChoose = false;
        return e;
      });
    },
    // 获取职业筛选配置
    async getJobFilterOption() {
      const res = await this.$axios.get("/php/job.list");
      console.log(res.data.data);
      res.data.data.map((item) => {
        this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.concat(
          item.jobs
        );
      });
      // this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map((e)=>{
      //     e.isChoose = false
      //     return e
      // })
      // this.jobFilterOption.jobList = res.data.data
    },
    //切换专业 院校
    async clickTableData() {
      this.yearsCheckList.year = "";
      this.yearsCheckList.num = "";
      this.filterData.sortKey = "";
      this.filterData.sortOrder = "";
      this.soreType = 0;
      this.tableData = [];
      this.page = 1;
      await this.getPlanListData();
    },
    // 获取院校列表
    async getTableData() {
      await this.getPlanListData();
    },
    // 获取专业列表
    async getMajorTableData() {
      await this.getPlanListData();
    },
    // 获取职业列表
    async getJobTableData() {
      await this.getPlanListData();
    },
    //筛选条件---
    async getPlanListData() {
      let jobList = this.jobFilterData.jobList.map((e) => e.value);

      console.log(
        this.filterData,
        this.jobFilterData.jobList.map((e) => e.id),
        "===this.jobFilterData.keywordInfo",
        this.jobFilterData
      );

      const res = await this.$axios.post("/php/plan.list.get", {
        //院校优先
        province: this.filterData.provinces.map((e) => e.name),
        categories: this.filterData.categories.map((e) => e.value),
        features: this.filterData.features.map((e) => e.value),
        collegeList: this.filterData.school.map((e) => e.name),
        // collegeList:
        // this.filterData.keyword.length > 0 ? [this.filterData.keyword] : [],
        newCollege: this.filterData.newCollege.map((e) => e.value),
        //专业优先
        majorList:
          this.majorFilterData.keyword.length > 0
            ? this.majorFilterData.majorList
              .map((e) => e.name)
              .concat([this.majorFilterData.keyword])
              .concat(this.userEvaluation.map((e) => e))
            : this.majorFilterData.majorList
              .map((e) => e.name)
              .concat(this.userEvaluation.map((e) => e)),
        majorType: this.majorFilterData.majorType.map((e) => e.name),
        newMajor: this.majorFilterData.newMajor.map((e) => e.value),
        cost: this.majorFilterData.cost.map((e) => e.value),
        //职业优先

        // jobList:
        //   this.jobFilterData.keyword.length > 0
        //     ? jobList.concat([this.jobFilterData.keywordInfo.value])
        //     : jobList,
        jobList: this.jobFilterData.jobList.map((e) => e.id || e.value),
        pcId: this.$route.query.id,
        chooseSubject: this.chooseSubject,
        listType: this.secondActiveName,
        sortKey: this.filterData.sortKey,
        sortOrder: this.filterData.sortOrder,
        minScore: this.sliderValue[0],
        maxScore: this.sliderValue[1],
        page: this.page,
      });
      if (this.secondActiveName === "2") {
        // this.tableData = [];
        res.data.data.list.map((e) => {
          e.isOpen = false;
          return e;
        });
      }
      if (this.secondActiveName === "3") {
        // this.tableData = [];
        res.data.data.list.map((e) => {
          e.isOpen = false;
          return e;
        });
      }

      if (res.data.ret == 0) {
        this.tableData = this.tableData.concat(res.data.data.list);

        this.total[this.secondActiveName] = res.data.data.total;
        console.log(res.data.data);
        this.loading = false;
        this.$toast.clear();
      } else {
        this.loading = false;
        this.$toast.clear();
        this.$toast(res.data.msg);
      }

      this.__loading = false
    },
    // 专业选择
    changeMajorType(name) {
      this.majorFilterData.features = [name];
      this.majorFilterOption.features = this.majorFilterOption.features.map((e) => {
        e.isChecked = e.name === name;
        return e;
      });
      this.filterData.features = [];
      this.filterOption[2].list = this.filterOption[2].list.map((e) => {
        e.isChecked = false;
        return e;
      });
      this.getTableData();
    },
    openMajorFilter(tag) {
      if (tag.eduLevel === "ben") {
        // 遍历数组，将当前点击的项的isChecked属性取反
        this.arr_ben = this.arr_ben.map((e) => {
          if (e.id == tag.id) {
            e.isChoose ? (e.isChoose = false) : (e.isChoose = true);
          }
          return e;
        });
      } else if (tag.eduLevel == "zhuan") {
        this.arr_zhuan = this.arr_zhuan.map((e) => {
          if (e.id == tag.id) {
            e.isChoose ? (e.isChoose = false) : (e.isChoose = true);
          }
          return e;
        });
      }
    },
    openJobFilter(tag) {
      this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map((e) => {
        if (e.id == tag.id) {
          e.isChoose ? (e.isChoose = false) : (e.isChoose = true);
        }
        return e;
      });
    },
    majorFilter(e, name) {
      console.log(e, name);
      // e为true时，添加到数组中，为false时，从数组中删除

      // if(e){
      //     this.majorFilterData.features.push(name)
      // }else{
      //     this.majorFilterData.features.splice(this.majorFilterData.features.indexOf(name),1)
      // }
    },
    clearMajorFilter(tag) {
      const res = tag.major.filter((e) => e.isChoose);
      // lodash的pullAll方法，删除this.majorFilterData.majorList数组中与res数组中相同的元素
      console.log(res);
      this.majorFilterData.majorList = _.pullAll(this.majorFilterData.majorList, res);
      this.majorFilterDataArr = _.pullAll(this.majorFilterDataArr, res);
      console.log(this.majorFilterData.majorList);
      if (tag.eduLevel === "ben") {
        this.arr_ben = this.arr_ben.map((e) => {
          if (e.id == tag.id) {
            e.major.map((a) => {
              a.isChoose = false;
              return a;
            });
          }
          return e;
        });
      } else if (tag.eduLevel == "zhuan") {
        this.arr_zhuan = this.arr_zhuan.map((e) => {
          if (e.id == tag.id) {
            e.major.map((a) => {
              a.isChoose = false;
              return a;
            });
          }
          return e;
        });
      }
    },
    clearJobFilter(tag) {
      const res = tag.jobs.filter((e) => e.isChoose);
      // lodash的pullAll方法，删除this.majorFilterData.majorList数组中与res数组中相同的元素
      let data = _.pullAll(this.jobFilterData.jobList, res);
      this.jobFilterData.jobList = [];
      this.jobFilterData.jobList = data;
    },
    setMajorFilter(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      const res = this.majorFilterData.majorList.filter((e) => e.name == item.name);
      console.log("===setMajorFilter", res);
      if (res && res.length > 0) {
        const data = this.majorFilterData.majorList.filter((e) => e.name != item.name);
        this.majorFilterData.majorList = data;
        console.log(this.majorFilterData.majorList, "===setMajorFilter>0", data);
      } else {
        item.type = "majorList";
        this.majorFilterData.majorList.push(item);
      }
      //   判断res数组中对象元素是否已经存在，存在则不添加，不存在的添加
      //= res.map((e) => {
      //   if (!this.majorFilterData.majorList.some((a) => a.name === e.name)) {
      //     this.majorFilterData.majorList.push(e);
      //   }
      // });
      this.getMajorTableData();
      // this.majorFilterData.majorList = this.majorFilterData.majorList.concat(res)
    },
    setJobFilter(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      const res = this.jobFilterData.jobList.filter((e) => e.name == item.name);
      if (res && res.length > 0) {
        const data = this.jobFilterData.jobList.filter((e) => e.name != item.name);
        this.jobFilterData.jobList = data;
        console.log(this.jobFilterData.jobList, "===setMajorFilter>0", data);
      } else {
        item.type = "jobList";
        this.jobFilterData.jobList.push(item);
      }
      //   判断res数组中对象元素是否已经存在，存在则不添加，不存在的添加
      // res.map((e) => {
      //   if (!this.jobFilterData.jobList.some((a) => a.id === e.id)) {
      //     this.jobFilterData.jobList.push(e);
      //   }
      // });
      this.getJobTableData();
      // this.majorFilterData.majorList = this.majorFilterData.majorList.concat(res)
    },
    majorFilterClick(secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = specialType;
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.majorFilterData[type] = [];
        if (type === "majorList") {
          if (this.majorFilterData.features[0] == "本科") {
            this.arr_ben = this.arr_ben.map((e) => {
              e.isChoose = false;
              e.major.map((a) => {
                a.isChoose = false;
                return a;
              });
              return e;
            });
          } else {
            this.arr_zhuan = this.arr_zhuan.map((e) => {
              e.isChoose = false;
              e.major.map((a) => {
                a.isChoose = false;
                return a;
              });
              return e;
            });
          }
        } else {
          this.majorFilterOption[type].list = this.majorFilterOption[type].list.map(
            (e) => {
              e.isChecked = false;
              return e;
            }
          );
        }
        this.getMajorTableData();
        return false;
      }
      const data = this.majorFilterOption["majorType"].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.majorFilterData[type] = _.without(this.majorFilterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.majorFilterData[type].push(data);
      }
      this.getMajorTableData();
      data.isChecked = !data.isChecked;
    },
    jobFilterClick(secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = specialType;
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.jobFilterData[type] = [];
        this.jobFilterOption[type].list = this.jobFilterOption[type].list.map((e) => {
          e.isChecked = false;
          return e;
        });
        this.getJobTableData();
        return false;
      }
      const data = this.jobFilterOption[type].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.jobFilterData[type] = _.without(this.jobFilterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.jobFilterData[type].push(data);
      }
      this.getJobTableData();
      data.isChecked = !data.isChecked;
    },
    costFilterClick(secondIndex) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = "cost";
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.majorFilterData[type] = [];
        this.majorFilterOption[type].list = this.majorFilterOption[type].list.map((e) => {
          e.isChecked = false;
          return e;
        });
        this.getMajorTableData();
        return false;
      }
      const data = this.majorFilterOption[type].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.majorFilterData[type] = _.without(this.majorFilterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.majorFilterData[type].push(data);
      }
      this.getMajorTableData();
      data.isChecked = !data.isChecked;
    },
    filterClick(firstIndex, secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = "";
      switch (firstIndex) {
        case 0:
          type = "provinces";
          break;
        case 1:
          type = "categories";
          break;
        case 2:
          specialType && specialType == "newCollege"
            ? (type = "newCollege")
            : (type = "features");
          break;
        case 3:
          type = "school";
          break;
      }
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.filterData[type] = [];
        this.filterOption[firstIndex].list = this.filterOption[firstIndex].list.map(
          (e) => {
            e.isChecked = false;
            return e;
          }
        );
        this.getTableData();
        return false;
      }
      const data = this.filterOption[firstIndex].list[secondIndex];
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.filterData[type] = _.without(this.filterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.filterData[type].push(data);
      }
      this.getTableData();
      data.isChecked = !data.isChecked;
    },
    //高级筛选
    highFilter(e, name) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.tableData = [];
      this.page = 1;
      console.log(e, "===高级筛选", name);
      this.chooseSubjectData = this.chooseSubject;
      console.log("===高级筛选==", this.chooseSubject);
      this.getTableData();
    },
    // 搜索大学（大于两个字符搜索）
    async search(queryString, cb) {
      if (!this.isShowMore) {
        cb([]);
        this.showMore();
        return false;
      }
      if (queryString.length > 1) {
        let requestParams = {
          keywords: queryString,
          pcId: this.$route.query.id,
          type: this.activeName,
        };

        const res = await this.$axios.get(
          "/php/plan.keywords.get?" + getParams(requestParams)
        );
        console.log(res.data.data);
        if (
          this.activeName == "college" ||
          this.activeName == "job" ||
          this.activeName == "major"
        ) {
          res.data.data.unshift({
            value: `在推荐结果中搜索“${queryString}”`,
            name: queryString,
          });
        }
        cb(res.data.data);
      } else {
        cb([]);
      }
    },
    highLightText(text, keyword) {
      if (keyword) {
        return text.replace(
          new RegExp(keyword, "g"),
          '<span style="color:#910000">' + keyword + "</span>"
        );
      } else {
        return text;
      }
    },
    // 选择搜索结果
    handleSelect(item) {
      this.page = 1;
      this.tableData = [];
      switch (this.activeName) {
        case "college":
          this.filterData.keyword = item.name;
          this.searchData.college = item.name;

          console.log(this.filterData, "===college", item);
          item.type = "school";

          let _item = this.filterData.school.find((val) => {
            return val.name == item.name;
          });
          console.log(this.filterData.school, "===college===", _item);
          if (!_item) {
            this.filterData.school.push(item);
          }
          this.getTableData();
          break;
        case "major":
          this.majorFilterData.keyword = item.name;
          this.searchData.major = item.name;
          // let majorRes = this.majorFilterDataArr.filter(
          //   (e) => e.name == item.name
          // );
          // if (!(majorRes && majorRes.length > 0)) {
          //   this.majorFilterDataArr.push(item);
          // }
          // this.getMajorTableData();
          item.type = "majorList";
          let _majorItem = this.majorFilterData.majorList.find((val) => {
            return val.name == item.name;
          });

          if (!_majorItem) {
            this.majorFilterData.majorList.push(item);
          }
          this.getTableData();
          break;
        case "job":
          this.jobFilterData.keyword = item.name;
          this.jobFilterData.keywordInfo = item;
          this.searchData.job = item.name;
          // let jobRes = this.jobFilterDataArr.filter((e) => e.name == item.name);
          // if (!(jobRes && jobRes.length > 0)) {
          //   this.jobFilterDataArr.push(item);
          // }
          // this.getJobTableData();
          item.type = "jobList";

          let _jobItem = this.jobFilterData.jobList.find((val) => {
            return val.name == item.name;
          });

          if (!_jobItem) {
            this.jobFilterData.jobList.push(item);
          }
          console.log(this.jobFilterData.jobList, _jobItem, "jobList", item);
          this.getTableData();
          break;
      }
    },
    handleSelectClear(item) {
      return false;
      switch (this.activeName) {
        case "college":
          const collegeData = this.filterData.school.filter(
            (e) => e.name == this.searchData.college
          );
          this.filterData.school = collegeData;
          console.log(this.filterDataArr, "===collegeData", collegeData);
          // this.removeFilterDataItem(collegeData)
          this.searchData.college = "";
          this.getTableData();
          break;
        case "major":
          const majorData = this.majorFilterData.majorList.filter(
            (e) => e.name == this.searchData.major
          );

          this.majorFilterData.majorList = majorData;
          // this.removeMajorFilterDataItem(majorData);
          this.searchData.major = "";
          this.getMajorTableData();
          break;
        case "job":
          const jobData = this.jobFilterData.jobList.filter(
            (e) => e.name == this.searchData.job
          );

          this.jobFilterData.jobList = jobData;
          // this.removeJobFilterDataItem(jobData);
          this.searchData.job = "";
          this.getJobTableData();
          break;
      }
    },
    handleSelectMajor(data) {
      console.log(data);
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.getMajorTableData();
    },
    handleClearSchool() {
      this.getTableData();
    },
    //清空
    async clearFilterData() {
      this.$toast({
        type: "loading",
        duration: 0,
        message: "加载中...",
        overlay: true,
      });
      this.containerLoading = true;
      this.page = 1;
      this.tableData = [];
      await this.getPlanConfig();
      await this.getFilterOption();
      await this.getJobFilterOption();
      await this.getMajorFilterOption();
      await this.getMajorTestList();
      this.jobFilterData = {
        jobList: [],
        keyword: "",
        keywordInfo: {},
        sortKey: "",
        sortOrder: "",
      };
      this.filterData = {
        provinces: [],
        features: [],
        categories: [],
        newCollege: [],
        keyword: "",
        sortKey: "",
        sortOrder: "",
        collegeList: [],
        school: [],
      };
      this.majorFilterData = {
        features: ["本科"],
        majorList: [],
        majorType: [],
        newMajor: [],
        cost: [],
        keyword: "",
      };
      this.majorFilterOption.majorType.list = this.majorFilterOption.majorType.list.map(
        (e) => {
          e.isChecked = false;
          return e;
        }
      );
      this.userEvaluation = [];
      await this.getTableData();
      this.containerLoading = false;
    },
    // 滑块改变
    handleSliderChange(val) {
      this.page = 1;
      this.tableData = [];
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.getData();
    },
    isShowVip() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
    },
    // 删除filerData中的某一项
    removeMajorFilterDataItem(item) {
      console.log(item);
      let type = item.type ? item.type : "majorList";
      this.majorFilterData[type] = _.without(this.majorFilterData[type], item);
      // forEach遍历majorFilterOption对象，将isChecked置为false
      if (type == "majorList") {
        if (this.majorFilterData.features.includes("本科")) {
          this.arr_ben = this.arr_ben.map((e) => {
            e.major = e.major.map((a) => {
              if (a.id == item.id) {
                a.isChoose = false;
              }
              return a;
            });
            e.major.filter((a) => a.isChoose).length > 0
              ? (e.isChoose = true)
              : (e.isChoose = false);
            return e;
          });
        } else {
          this.arr_zhuan = this.arr_zhuan.map((e) => {
            e.major = e.major.map((a) => {
              if (a.id == item.id) {
                a.isChoose = false;
              }
              return a;
            });
            e.major.filter((a) => a.isChoose).length > 0
              ? (e.isChoose = true)
              : (e.isChoose = false);
            return e;
          });
        }
      } else if (type == "userEvaluation") {
        this.userEvaluation = this.userEvaluation.filter((e) => e !== item.value);
      } else {
        type == "newMajor" ? (type = "majorType") : "";
        this.majorFilterOption[type].list.forEach((e) => {
          console.log(e.value, item.value);
          if (e.value === item.value) {
            e.isChecked = false;
          }
        });
      }
      this.getMajorTableData();
    },
    removeJobFilterDataItem(item) {
      console.log(item);
      this.jobFilterData.jobList = _.without(this.jobFilterData.jobList, item);
      // forEach遍历majorFilterOption对象，将isChecked置为false
      this.jobFilterOption.jobList.list.forEach((e) => {
        e.jobs = e.jobs.map((a) => {
          if (a.id == item.id) {
            a.isChoose = false;
          }
          return a;
        });
        e.jobs.filter((a) => a.isChoose).length > 0
          ? (e.isChoose = true)
          : (e.isChoose = false);
        return e;
      });
      this.getJobTableData();
    },
    // 删除filerData中的某一项
    removeFilterDataItem(item) {
      console.log(this.filterData, "====removeFilterDataItem", item);
      this.filterData[item.type] = _.without(this.filterData[item.type], item);
      this.filterOption.map((e) => {
        if (e.type === item.type) {
          e.list.map((a) => {
            if (a.value === item.value) {
              a.isChecked = false;
            }
            return a;
          });
        }
        return e;
      });
      this.getTableData();
    },
    // table排序
    handleSortChange(year) {
      this.page = 1;
      this.tableData = [];
      this.soreType = 0;
      this.filterData.sortKey = "";
      let _year = this.planConfig.recentYears[year - 1];
      if (_year == this.yearsCheckList.year) {
        this.yearsCheckList.num =
          this.yearsCheckList.num < 3 ? this.yearsCheckList.num + 1 : 1;
      } else {
        this.yearsCheckList.year = "";
        this.yearsCheckList.num = 0;
        if (this.yearsCheckList.year) {
          this.yearsCheckList.num = 0;
        } else {
          this.yearsCheckList.num = this.yearsCheckList.num + 1;
        }
        this.yearsCheckList.year = _year;
      }
      console.log(_year, "table排序", this.yearsCheckList.year, year, this.yearsCheckList.num);
      this.filterData.sortKey = "minScore" + year;
      if (this.yearsCheckList.num == 1) {
        this.filterData.sortOrder = "asc";
      } else if (this.yearsCheckList.num == 2) {
        this.filterData.sortOrder = "desc";
      } else {
        this.filterData.sortOrder = "";
      }
      // this.filterData.sortOrder == 'ascending' ? 'asc' : 'desc';
      this.getTableData();
    },
    //计划增减排序
    handleSort() {
      this.page = 1;
      this.tableData = [];
      this.yearsCheckList.year = "";
      if (this.soreType <= 2) {
        this.soreType = this.soreType + 1;
      } else {
        this.soreType = 1;
      }
      if (this.soreType == 0) {
        this.filterData.sortKey = "";
        this.filterData.sortOrder = "";
      }
      if (this.soreType == 1) {
        this.filterData.sortKey = "planNumDiff";
        this.filterData.sortOrder = "asc";
      }
      if (this.soreType == 2) {
        this.filterData.sortKey = "planNumDiff";
        this.filterData.sortOrder = "desc";
      }

      this.getTableData();
    },
    // 查看院校详情
    viewCollegeDetail(data) {
      const param = {
        id: data.collegeCode,
        name: data.collegeName,
      };
      this.$router.push("/college/detail?" + getParams(param));
    },
    getData() {
      switch (this.activeName) {
        case "college":
          this.getTableData();
          break;
        case "major":
          this.getMajorTableData();
          break;
        case "job":
          this.getJobTableData();
          break;
      }
    },
    handleClick(tab, event) {
      switch (this.activeName) {
        case "college":
          this.getFilterOption();
          break;
        case "major":
          this.getMajorFilterOption();
          break;
        case "job":
          this.getJobFilterOption();
          break;
      }
    },
    // 展开子节点
    async handleExpand(scope) {
      this.majorDataShow = true;
      this.majorData = scope;
      console.log("==展开专业", scope);
      // 关闭所有展开的子节点
      // this.tableData.map((e,i) => {
      //     if (i !== scope.$index) {
      //         e.isOpen = false
      //         this.$refs.table.toggleRowExpansion(this.tableData[i], false)
      //     }
      //     return e
      // })
      // this.tableData[scope.$index].isOpen = !this.tableData[scope.$index].isOpen
      // this.$refs.table.toggleRowExpansion(this.tableData[scope.$index], this.tableData[scope.$index].isOpen)
      // const res = await this.$axios.get('/php/plan.list.collegeMajor.get?' + getParams({
      //     pcId: this.$route.query.id,
      //     collegeEnrollCode: scope.row.collegeEnrollCode
      // }))
      // this.tableChildrenData = res.data.data.list
      // console.log(scope)
      // console.log('展开')
      let res = []
      if (this.planConfig.listType && this.planConfig.listType.indexOf(3) > -1) {
        res = await this.$axios.get('/php/plan.list.collegeMajorGroupMajor.get?' + getParams({
          pcId: this.$route.query.id,
          collegeMajorGroupCode: scope.collegeMajorGroupCode
        }))
      } else {
        res = await this.$axios.get(
          "/php/plan.list.collegeMajor.get?" +
          getParams({
            pcId: this.$route.query.id,
            collegeEnrollCode: scope.collegeEnrollCode,
          })
        );
      }
      this.tableChildrenData = res.data.data.list;
    },
    // 删除对比
    removeCompare(data, type) {

      if (type === "all") {
        //2024.11.01 修改了志愿表的数据结构 (listType==3或者listType==2)
        if (this.planConfig.listType.length === 1 && this.planConfig.listType[0] == 3) {
          this.compareCollegeList = this.compareCollegeList.filter(e => e.collegeMajorGroupCode != data)
        } else {
          this.compareCollegeList = this.compareCollegeList.filter(e => e.collegeCode != data)
        }
      } else {
        this.compareCollegeList = _.without(this.compareCollegeList, data);
        this.checkedColleges = _.without(this.checkedColleges, data);
      }
    },
    //一填报
    removeCompareList(data) {
      this.compareCollegeList = _.differenceBy(this.compareCollegeList, [data], "id");
      // this.compareCollegeList = _.without(compareCollegeList, data)
    },
    // 添加对比
    addCompareList(data) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.compareCollegeList.push(data);
    },
    isChecked(id) {
      const arr = this.compareCollegeList.filter((e) => e.id === id);
      return arr.length > 0;
    },
    //预览志愿表
    clickCompare() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.compareShow = true;
    },
    //     保存志愿表
    async savePlan() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      // if (this.limit.now >= this.limit.max) {
      //   this.$message({
      //     message: '您的今日可修改次数已达上限',
      //     type: 'warning',
      //   });
      //   return false;
      // }
      // 最少选择3个院校
      if (this.compareCollegeList.length < 3) {
        this.$message({
          message: "最少选择3个志愿",
          type: "warning",
        });
        return false;
      }

      const res = await this.$axios.post("/php/user.plan.save", {
        pcId: this.$route.query.id,
        plan: this.compareCollegeList.map((e) => e.id),
      });
      console.log(res);
      if (res.data.ret == 0) {
        this.$message({
          message: "保存成功",
          type: "success",
        });

        localStorage.setItem("savePlan", JSON.stringify(this.compareCollegeList));
        let id = encodeURIComponent(res.data.data.id);
        setTimeout(() => {
          // 跳转到志愿表详情
          this.$router.push("/tzy/details?id=" + res.data.data.id);
        }, 800);
      }
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(_.pickBy(this.form, _.identity));
          // lodash _.pickBy(this.form, _.identity)  去除对象中值为空的属性返回新对象
          let data = _.pickBy(this.form, _.identity);
          // 判断this.scoreOption[this.currentProvinceInfo.type].course1 是否存在 并且 ...must == 1 true则data.course1 = data.course1[0] false则data.course1 = data.course1
          if (
            this.scoreOption[this.currentProvinceInfo.type].course1 &&
            this.scoreOption[this.currentProvinceInfo.type].course1.must == 1
          ) {
            data.course1 = data.course1[0];
          } else {
            data.course1 = data.course1;
          }
          if (
            this.scoreOption[this.currentProvinceInfo.type].course2 &&
            this.scoreOption[this.currentProvinceInfo.type].course2.must == 1
          ) {
            data.course2 = data.course2[0];
          } else {
            data.course2 = data.course2;
          }
          // 去除data对象中值为空的数组
          for (let key in data) {
            if (data[key].length == 0) {
              delete data[key];
            }
          }

          const res = await this.$axios.post("/php/user.score.set", data);
          if (res.data.ret === 0) {
            this.$message({
              message: "创建成功",
              type: "success",
            });
            this.dialogVisible = false;
            await this.getUserInfo();
            await this.getData();
            //   清除表单
            this.$refs[formName].resetFields();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    nav(data) {
      this.$router.replace({
        path: "/accounts/oneFilling",
        query: { id: this.$route.query.id, batchName: data.bzType },
      });
    },
    async showMore() {
      this.vipDialogVisible = true;
      // await this.getGridData()
    },
    openVip() {
      this.vipDialogVisible = false;
      this.showModal = true;
      this.compareShow = false;
    },
    //获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },

    //获取文档完整的高度
    getScrollHeight() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    },

    //获取当前滚动条的位置
    getScrollTop() {
      var scrollTop = 0;
      //window.pageYOffset = document.documentElement.scrollTop
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    // 防抖函数
    debounce(fn, delay) {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          console.log("防抖");
          fn.apply(context, args);
        }, delay);
      };
    },
    //回调函数
    async windowScroll() {
      let top = this.$refs.obtain.getBoundingClientRect().top;
      let h = window.getComputedStyle(this.$refs.obtain1).height; // 100px
      let h1 = document.querySelector('.score-range-wrapper').offsetHeight;
      let h2 = document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').offsetHeight;
      console.log(h1, h2, h, "距离顶部高度", this.$refs.obtain.getBoundingClientRect().top);
      if (top - 56 < 2) {
        this.styleObj.position = "fixed";
        this.styleObj.borderTop = "1px solid #ddd";
        this.styleObj.borderBottom = "1px solid #ddd";
        this.styleObj1.paddingTop = h;
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.top = h1 + h2 + 10 + 'px'
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.position = "fixed";
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.zIndex = 9;
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.background = '#f1f1f1';
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.width = '94%';
      } else {
        this.styleObj.position = "";
        this.styleObj.borderTop = "";
        this.styleObj.borderBottom = "";
        this.styleObj1.paddingTop = "";
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.top = ''
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.position = "";
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.zIndex = 0;
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.background = '';
        document.querySelector('.tab-box .middle .el-tabs--card > .el-tabs__header').style.width = '';
      }

      //获取三个值
      var scrollTop = this.getScrollTop();
      var clientHeight = this.getClientHeight();
      var scrollHeight = this.getScrollHeight();
      if (scrollTop > 200) {
        this.topShow = true;
      } else {
        this.topShow = false;
      }
      let delta = scrollTop - this.oldScrollTop;
      // if( delta === 0 ) return false;
      if (delta > 0) {
        clearInterval(this.timeTop);
      }
      if (delta < 0) {
      }
      this.oldScrollTop = scrollTop;
      //如果满足公式则，确实到底了
      console.log(delta, "如果满足公式则", this.page * clientHeight, scrollTop, clientHeight, scrollHeight);
      //scrollTop + clientHeight >= scrollHeight - 8
      let _scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const isBottom = scrollHeight - (_scrollTop + clientHeight);
      if (isBottom < 20) {
        if (this.__loading) {
          return true
        }
        this.__loading = true
        //发送异步请求请求数据，同时携带offset并自增offset
        //noMore是自定义变量，如果是最后一批数据则以后都不加载
        console.log("滚动到底部");
        if (!this.isShowMore) {
          this.showMore();
          return false;
        }

        setTimeout(() => {
          this.page = this.page + 1;
          // debugger
          this.getPlanListData();
        }, 600);
        // if (this.activeName === "college") {
        //   if (!this.noMore) {
        //     this.debounce(this.getTableData(), 3000);
        //   }
        //   return true
        // } else if (this.activeName === "major") {
        //   if (!this.noMore) {
        //     this.debounce(this.getMajorTableData(), 3000);
        //   }
        // } else if (this.activeName === "job") {
        //   if (!this.noMore) {
        //     this.debounce(this.getJobTableData(), 3000);
        //     // this.getJobTableData('loadMore')
        //   }
        // }

      }
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    clickFillBtn(i) {
      console.log(this.$refs[`item_${i}`], "===clickFillBtn", this.$refs);
      this.$refs[`item_${i}`][0].toggle();
    },
    clickFillBtn1(i) {
      console.log(this.$refs[`item_${i}`], "===clickFillBtn", this.$refs);
      this.$refs[`item_${i}`].toggle();
    },
    handleMajor(e) {
      console.log("handleMajor", e);
    },
    handleJob(e) {
      console.log("handleJob", e);
    },
    removeNewFilterDataItem(item) {
      console.log("====removeNewFilterDataItem", item);
      const list = ["provinces", "features", "categories", "newCollege", "school"];
      const list1 = ["cost", "newMajor", "majorList", "majorType", "userEvaluation"];
      const list2 = ["jobList"];
      const list3 = ["chooseSubject"];
      if (list.includes(item.type)) {
        this.removeFilterDataItem(item);
        //   if (item.type == 'school') {
        //    const collegeData = this.filterData.school.filter(
        //       (e) => e.name == this.searchData.college
        //     );
        //     this.filterData.school = collegeData;
        // }
      } else if (list1.includes(item.type)) {
        this.removeMajorFilterDataItem(item);
      } else if (list2.includes(item.type)) {
        this.removeJobFilterDataItem(item);
      } else if (list3.includes(item.type)) {
        this.chooseSubjectData = this.chooseSubjectData.filter((e) => e !== item.name);
        this.chooseSubject = this.chooseSubjectData;
        // this.getTableData();
      }
      this.searchData.college = "";
      this.searchData.major = "";
      this.searchData.job = "";
      this.filterData.keyword = "";
      this.majorFilterData.keyword = "";
      this.jobFilterData.keyword = "";
      this.getTableData();
    },
    removeItem(item) {
      this.$toast({
        type: "loading",
        duration: 0,
        message: "加载中...",
        overlay: true,
      });
      const list = ["provinces", "features", "categories", "newCollege", "school"];
      const list1 = ["cost", "newMajor", "majorList", "majorType", "userEvaluation"];
      const list2 = ["jobList"];
      const list3 = ["chooseSubject"];
      // if (list.includes(item.type)) {
      //    const collegeData = this.filterData.school.filter(
      //       (e) => e.name == this.searchData.college
      //     );
      //     this.filterData.school = collegeData;
      // }
      if (list.includes(item.type)) {
        this.removeFilterDataItem(item);
        if (item.type == "school") {
          this.searchData.college = "";
          this.filterData.keyword = "";
        }
      } else if (list1.includes(item.type)) {
        this.removeMajorFilterDataItem(item);
        console.log(
          this.majorFilterData.keyword,
          this.searchData.major,
          "====ssss",
          item.type
        );
        if (item.name == this.majorFilterData.keyword) {
          this.majorFilterData.keyword = "";
          this.searchData.major = "";
        }
      } else if (list2.includes(item.type)) {
        this.removeJobFilterDataItem(item);
        if (item.name == this.jobFilterData.keyword) {
          this.jobFilterData.keyword = "";
          this.searchData.job = "";
        }
      } else if (list3.includes(item.type)) {
        this.chooseSubjectData = this.chooseSubjectData.filter((e) => e !== item.name);
        this.chooseSubject = this.chooseSubjectData;
        this.getTableData();
      }
    },
  },
};
</script>

<style lang="scss">
.el-dialog {
  margin: 0 auto !important;
}

.compare_box {
  .el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    min-height: 80vh;
  }
}

.info_nav {
  display: flex;
  position: fixed;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 87%;
  z-index: 99;
  top: 0;
  background: #fff;
  height: 52px;
  border-bottom: 1px solid #ddd;

  div {
    color: #333;
    font-size: 14px;
    margin-right: 5px;
    font-weight: 800;
  }

  .back {
    color: #333;
    font-size: 18px;
    font-weight: 800;
    margin-right: 8px;
    padding-left: 15px;
  }
}

.major-active {
  color: #910000;
  border: 1px solid #910000;
  padding: 4px;
  border-radius: 4px;
}

.tab-box {
  position: relative;

  .top {
    .el-tabs__item.is-active {
      color: #910000 !important;
    }

    .el-tabs__item:hover {
      color: #910000 !important;
    }

    .el-tabs__item {
      width: calc(100vw / 3);
      text-align: center;
    }

    .el-tabs__nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 0 !important;
    }

    /deep/ .el-tabs__nav-wrap.is-scrollable {
      padding: 0 15px !important;
    }
  }

  .user-info {
    position: fixed;
    right: 0;
    top: 0;
    font-size: 12px;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 51px;
    z-index: 2;
    width: 100%;
    padding: 0 15px;
    height: 51px;
    background: #f1f1f1;
    z-index: 99999;
  }

  .nav {
    // width: 30%;
    display: block;
    text-align: center;
  }

  .filter-list {
    // border-bottom: 1px dashed #e5e5e5;
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    // -webkit-box-align: start;
    // -ms-flex-align: start;
    // align-items: flex-start;
    padding: 15px 6px 8px 15px;

    .filter-list-title {
      line-height: 20px;
      font-size: 16px;
      color: #212121;
      font-weight: 700;
      padding-bottom: 10px;
    }

    .filter-list-tags {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      justify-content: flex-start;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;

      .tag {
        width: 25%;
        text-align: center;
        height: 36px;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: 10px;

        .tag_box {
          -webkit-transition: 0.2s ease-in-out;
          transition: 0.2s ease-in-out;
          width: 100%;
          border: 1px solid transparent;
          font-size: 14px;
          color: #666;
          border-radius: 4px;
          margin-right: 8px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          background-color: #f2f2f2;
          position: relative;
          overflow: hidden;
        }

        .small {
          cursor: pointer;
          margin-bottom: 10px;
          color: #666;
          float: left;
        }

        .tag_icon {
          border: 1px solid #910000;
          position: absolute;
          bottom: -2px;
          right: -2px;
          border-radius: 4px 0 4px 0;
          background: #910000;
          color: #fff;
          font-size: 14px;
        }
      }

      .active.tag_box {
        color: #910000;
        border: 1px solid #910000;
        background: #fff;
      }
    }

    .el-input--suffix .el-input__inner {
      line-height: 40px !important;
      height: 40px !important;
    }
  }

  .myFilterRecordBlockRow {
    overflow: hidden;
    height: auto;
    -webkit-transition: all 2s ease-in-out;
    transition: all 2s ease-in-out;

    .fill_box_title {
      padding: 0 15px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      line-height: 18px;
      margin-bottom: 10px;
    }

    .customer-selected-tags {
      padding-left: 5px;
      margin-right: 25px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;

      .tag {
        position: relative;
        padding: 4px 8px 4px 12px;
        background: #fff;
        border-radius: 13px;
        border: 1px solid #999;
        text-align: center;
        margin-left: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        font-weight: 500;
        color: #9b9b9b;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        .el-icon-close {
          vertical-align: middle;
          padding-left: 5px;
        }
      }
    }
  }

  .middle {
    .el-tabs--card>.el-tabs__header {
      border-bottom: 1px solid #910000;
    }

    .el-tabs__item.is-active {
      color: #fff;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background: #910000;
      color: #fff !important;
      border-radius: 4px 4px 0 0;

      .el-dropdown {
        color: #ffffff;
      }
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item {
      border: none;
      font-size: 16px;
      padding: 0 33px !important;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .el-table .ascending .sort-caret.ascending {
      border-bottom-color: #910000;
    }

    .el-table .descending .sort-caret.descending {
      border-top-color: #910000;
    }

    .score-range-wrapper {
      flex: 1;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
      width: 100vw;
      padding: 20px 0;
      font-size: 14px;
      background: #fff;

      .vue-slider-rail {
        background: #f0f0f0;
      }

      .score-box {
        display: flex;
        align-items: center;
        width: 100vw;
        padding: 0 15px;
        font-size: 16px;

        span {
          font-weight: 800;
        }

        .is-checked {
          .el-checkbox__label {
            color: #910000 !important;
          }

          .el-checkbox__inner {
            border: 1px solid #910000;
            background: #910000;
          }
        }

        .vue-slider-dot {
          height: auto !important;
        }

        .vue-slider-dot:nth-child(2) {
          height: auto !important;
          // transform: translate(-10%, -50%) !important;
        }

        .el-slider__button-wrapper {
          z-index: 2;
        }
      }

      .score-box1 {
        padding-bottom: 15px;
      }

      .score-range {
        // display: -webkit-box;
        // display: -ms-flexbox;
        // display: flex;
        // -webkit-box-align: center;
        // -ms-flex-align: center;
        // align-items: center;
        // -webkit-box-pack: end;
        // -ms-flex-pack: end;
        // justify-content: flex-end;
        width: 100vw;

        .slider {
          width: 60vw;
        }

        /deep/ .el-slider__bar {
          background: #910000;
        }

        /deep/ .el-slider__button {
          border: 1px solid #910000;
          background: #910000;
        }
      }
    }

    .table-content {
      .el-table th>.cell {
        display: flex;
        align-items: center;
      }

      .customHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .table-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        a {
          cursor: pointer;
          color: #333333;
        }

        a:hover {
          color: #910000;
        }

        .tag {
          border-radius: 3px;
          color: #fff;
          padding: 4px;
          line-height: 24px;
          font-size: 12px;
        }
      }
    }
  }

  .p-10 {
    padding: 10px;
  }

  .color9b {
    color: #9b9b9b;
  }
}

.fill_tabs_box {
  .el-tabs__content {
    padding: 0 0 15px;
  }

  .van-dropdown-menu {
    font-size: 12px;
    font-weight: 800;
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-bottom: none;
  }

  .search_box {
    padding: 0 15px;

    .el-autocomplete {
      width: 100%;
    }

    .el-input--prefix .el-input__inner {
      border-radius: 20px;
      background: #f8f8f8;
    }
  }

  .filter-action {
    display: flex;
    padding: 0 20px 15px;

    .van-button {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: #910000;
      border-color: #910000;
      height: 40px;
      border-radius: 50px;
    }
  }

  .van-sidebar {
    width: 110px;
    overflow-y: auto;
    max-height: 28vh;
  }

  .fill_tabs_box_tags {
    display: flex;
    justify-content: space-between;

    .right_box {
      width: calc(100vw - 110px);
      overflow-y: auto;
      max-height: 28vh;

      .filter-list-tags {
        padding: 10px 15px;
      }
    }
  }
}

.intelligent {
  .compare-pop {
    height: 80%;
    position: fixed;
    right: -366px;
    top: 120px;
    -webkit-transition: -webkit-transform 1s;
    transition: -webkit-transform 1s;
    transition: transform 1s;
    transition: transform 1s, -webkit-transform 1s;
    z-index: 1001;

    .fold-box {
      width: 366px;
      padding: 10px 15px;
      background-color: #fff;
      border: 1px solid #ccc;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;

      .compare-cart {
        position: absolute;
        left: -42px;
        top: -1px;

        .fold-btn {
          width: 42px;
          height: 206px;
          cursor: pointer;
          color: #fff;
          border-top-left-radius: 4px;
          background: #910000;

          .fold-text {
            width: 42px;
            height: 170px;
            -webkit-writing-mode: tb-rl;
            -ms-writing-mode: tb-rl;
            writing-mode: tb-rl;
            text-align: left;
            padding: 25px 13px 0;
            line-height: 20px;
            letter-spacing: 13px;
          }

          .compare-num {
            text-align: center;
          }
        }

        .save {
          background-color: #fff;
          color: #910000;
          font-size: 14px;
          width: 42px;
          height: 42px;
          border: 1px solid #910000;
        }

        .safe {
          border-bottom-left-radius: 4px;
        }
      }

      .roll {
        height: 420px;
        overflow-x: hidden;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .is-checked {
          .el-checkbox__label {
            color: #910000 !important;
          }
        }
      }

      .compare-li {
        width: 332px;
        height: 60px;
        line-height: 60px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        border-bottom: 1px solid #e9e7e7;
      }
    }

    .el-button--default {
      background-color: #910000 !important;
      color: #fff !important;
      border: none;
      width: 335px;
      height: 40px;
    }
  }

  .info {
    .el-tabs--card>.el-tabs__header {
      border-bottom: 1px solid #910000;
    }

    .el-tabs__item.is-active {
      color: #fff;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background: #910000;
      border-radius: 4px 4px 0 0;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item {
      border: none;
      font-size: 16px;
      padding: 0 33px !important;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .duibi-btn {
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 8px;
      position: absolute;
      right: 3px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      border: 1px solid #910000;
      color: #910000;
      padding: 8px 18px;
    }

    .duibi-added {
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 8px;
      position: absolute;
      right: 3px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      border: 1px solid #910000;
      background-color: #910000 !important;
      color: #fff;
    }

    .el-button.is-plain:focus,
    .el-button.is-plain:hover {
      background: #910000;
      border-color: #910000;
      color: #fff;
    }
  }

  .el-tag {
    height: 16px;
    line-height: 14px;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 4px;
    padding: 0 2px;
  }

  .el-input-group__append {
    background-color: #910000;
    color: #fff;
    border-radius: 0 4px 4px 0;
    border: none;
  }
}

.fixed-title {
  width: 100%;
  position: fixed;
  top: 45px;
  /* left: 0; */
  z-index: 2000;
}

.custom-header1:nth-child(1) {
  width: 90px;
}

.custom-header1:nth-child(2) {
  width: 420px;
}

.custom-header1:nth-child(3) {
  width: 130px;
}

.custom-header1:nth-child(4) {
  width: 50px;
}

.custom-header1:nth-child(5) {
  width: 90px;
}

.custom-header1:nth-child(6) {
  width: 90px;
}

.custom-header1:nth-child(7) {
  width: 90px;
}

.custom-header1:nth-child(8) {
  width: 130px;
}

.custom-header1:nth-child(9) {
  width: 100px;
}

.custom-header0:nth-child(1) {
  width: 90px;
}

.custom-header0:nth-child(2) {
  width: 200px;
}

.custom-header0:nth-child(3) {
  width: 240px;
}

.custom-header0:nth-child(4) {
  width: 130px;
}

.custom-header0:nth-child(5) {
  width: 50px;
}

.custom-header0:nth-child(6) {
  width: 90px;
}

.custom-header0:nth-child(7) {
  width: 90px;
}

.custom-header0:nth-child(8) {
  width: 90px;
}

.custom-header0:nth-child(9) {
  width: 130px;
}

.custom-header0:nth-child(10) {
  width: 90px;
}

.vip_box {
  padding: 10px 14px 10px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 99;
  border-top: 1px solid #ddd;

  .vip_btn {
    position: relative;
    height: auto;
    display: flex;
    justify-content: center;
    width: 100%;

    .btn {
      border-radius: 5px;
      height: 40px !important;
      line-height: 1.2;
      width: 40%;
      margin: 0 2%;
    }

    .btn1 {
      background: #fff;
      color: #212121;
      border: 1px solid #9b9b9b;
    }

    .btn2 {
      background: -webkit-linear-gradient(left, #ff6034, #ee0a24);
      background: #ee0a24; // linear-gradient(90deg, #ff6034, #ee0a24);
      border: none !important;
      color: #fff;
    }
  }
}

.major_title {
  font-family: PingFangSC-Medium, PingFang SC;
  color: #333;
  padding: 20px 16px;
  background: #fff;
  line-height: 24px;

  div {
    font-size: 22px;
  }

  p {
    font-size: 16px;
  }
}

.major_cont {
  overflow-y: auto;
  height: 69vh;
}

.tzy-container {
  // min-height: calc(100vh - 610px);
  padding-top: 12px;
  padding-bottom: 50px;
  background: #f8f5f4;
  padding-left: 12px;
  padding-right: 12px;

  .pl0 {
    padding-left: 0 !important;
  }

  .pb0 {
    padding-bottom: 0 !important;
  }

  .flex {
    display: flex;
  }

  .h5-college-tr {
    background: #fff;
    background: linear-gradient(#fff5ef, #fff 112px);
    padding-right: 12px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    border: 1px solid #fff;
  }

  .h5-college-tr .college-action {
    min-width: 10%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .h5-college-tr .college-action i {
    font-size: 22px;
  }

  .h5-college-tr .college-action i.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .h5-college-tr .college-action .el-icon-delete {
    margin: 5px 0;
    font-size: 14px;
  }

  .h5-college-tr .h5-major-tr_title {
    margin-bottom: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .h5-college-tr .h5-major-tr_title>a {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    line-height: 22px;
    color: #000;
    font-weight: 600;
  }

  .h5-college-tr .h5-major-tr_title>span {
    margin-left: 4px;
  }

  .h5-college-tr .percent {
    display: -webkit-box;
    padding-right: 12px;
    padding-left: 2px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
  }

  .h5-college-tr .percent .probab {
    position: relative;
    width: 32px;
    height: 30px;
    font-size: 14px;
    font-family: Bebas;
    color: #fff;
  }

  .h5-college-tr .percent .probab .probab-logo,
  .h5-college-tr .percent .probab .probab-logo img {
    width: 100%;
  }

  .h5-college-tr .percent .probab h1 {
    display: block;
    position: absolute;
    top: 6px;
    left: 4px;
    min-width: 25px;
    font-size: 14px;
    font-family: Bebas;
    color: #fff;
    letter-spacing: 0;
    line-height: 14px;
    text-align: center;
  }

  .majorNamePreview {
    font-weight: 800;
    font-size: 16px;
    color: #333;
    padding: 5px 0;
  }

  .h5-college-tr .percent p {
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 10px;
    color: #999;
    letter-spacing: 0;
    text-align: center;
    -webkit-transform: scale(0.83);
    transform: scale(0.83);
    margin-top: 3px;
  }

  .h5-college-tr .percent .recommend-type {
    height: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }

  .h5-college-tr .percent .recommend-type span {
    display: inline-block;
    border: 1px solid #fff;
    min-width: 40px;
    max-width: 100px;
    text-align: center;
    border-radius: 4px;
    padding: 4px 0;
  }

  .h5-college-tr .percent .recommend-type .chong {
    color: #910000;
    border-color: #910000;
  }

  .h5-college-tr .percent .recommend-type .wen {
    color: #ff9a02;
    border-color: #ff9a02;
  }

  .h5-college-tr .percent .recommend-type .bao {
    color: #0c3;
    border-color: #0c3;
  }

  .h5-college-tr .college {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-top: 15px;
    font-size: 12px;
    color: #999;
    letter-spacing: 0;
    line-height: 20px;
    word-break: break-all;
  }

  .h5-college-tr .college .college-info>div {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .h5-college-tr .college .college-info>div>p {
    color: #999;
  }

  .h5-college-tr .college .college-info a {
    display: inline-block;
    line-height: 18px;
    font-size: 16px;
    letter-spacing: 0;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #000;
    margin-bottom: 6px;
  }

  .h5-college-tr .college .college-intr {
    color: #666;
  }

  .college-code {
    color: #333;
  }

  .fw500 {
    font-weight: 500;
  }

  .h5-college-tr .college .plan {
    color: #333;
    margin-bottom: 8px;
  }

  .h5-college-tr .major {
    padding-top: 16px;
    padding-bottom: 15px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px;
    color: #9b9b9b;
    letter-spacing: 0;
    line-height: 20px;
    word-break: break-all;
  }

  .h5-college-tr .major .college-info a {
    line-height: 24px;
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .major .major-info a {
    line-height: 24px;
    font-size: 16px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .three-one-two-history .tabs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }

  .h5-college-tr .three-one-two-history .tabs>span {
    cursor: pointer;
  }

  .h5-college-tr .filter,
  .h5-college-tr .filter .iconfont {
    font-size: 12px;
  }

  .h5-college-tr .profession-count-button {
    display: inline-block;
    height: 28px;
    line-height: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    min-width: 56px;
    border: 1px solid #ccc;
    border-radius: 14px;
    font-size: 12px;
    letter-spacing: 0;
  }

  .h5-college-tr .profession-count-button {
    color: #910000;
    border: 1px solid #910000;
  }

  .h5-college-tr .fav {
    vertical-align: bottom;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    width: 20px;
    height: 20px;
    margin-bottom: 4px;
    border-radius: 50%;
  }

  .h5-college-tr .fav .iconfont {
    vertical-align: super;
    color: #ed4c4a;
    font-size: 14px;
  }

  .h5-college-tr .three-frame {
    margin-top: 8px;
    width: 30px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 14px;
  }

  .h5-college-tr .h5-default-table {
    color: #9b9b9b;
    font-size: 12px;
    line-height: 22px;
  }

  .h5-college-tr .h5-major-tr.dialog {
    background: #fff;
    background: linear-gradient(#ff4343, #fff 112px);
    border: 1px solid #fff;
    border-radius: 8px;
    padding-top: 15px;
    padding-bottom: 16px;
    margin-bottom: 10px;
    padding-right: 12px;
    font-size: 12px;
    color: #9b9b9b;
    letter-spacing: 0;
  }

  .h5-college-tr .h5-major-tr .percent h1 {
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    font-family: Bebas;
    color: #fff;
    line-height: 14px;
    white-space: nowrap;
  }

  .h5-college-tr .h5-major-tr .percent p {
    padding-bottom: 10px;
    font-size: 12px;
    letter-spacing: 0;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999;
    line-height: 10px;
  }

  .h5-college-tr .h5-major-tr .major-info {
    line-height: 20px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .h5-college-tr .h5-major-tr .major-info a {
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
  }

  .h5-college-tr .h5-major-tr .major-info .h5-major-tr_match {
    color: #999;
  }

  .h5-college-tr .h5-major-tr .major-info .h5-major-tr_code {
    margin-bottom: 8px;
    color: #333;
  }

  .h5-college-tr .h5-major-tr .major-action {
    min-width: 10%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .h5-college-tr .h5-major-tr .major-action i {
    font-size: 22px;
  }

  .h5-college-tr .h5-major-tr .major-action i.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .h5-college-tr .h5-major-tr .major-action .el-icon-delete {
    margin: 5px 0;
    font-size: 14px;
  }

  .h5-college-tr .h5-major-tr .van-overlay {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }

  .h5-college-tr .tzy-sort {
    float: left;
    width: 30px;
    height: 30px;
    line-height: 30px;
    color: #9b9b9b;
    border: 1px solid #9b9b9b;
    text-align: center;
    margin-left: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
  }
}

.foot-box {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-left: 0;
}

.text-flex {
  width: 143px;
}

.foot-box {
  z-index: 44;
  width: 100%;
  height: 60px;
  padding-left: 15px;
  padding-right: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ddd;
}

.foot-box .open,
.foot-box button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #910000;
  border-color: #910000;
  height: 40px;
}

.foot-box .open {
  width: 32%;
  height: 40px;
  border-radius: 4px;
}

.foot-box .text-flex {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.foot-box .foot-box-a {
  width: 32%;
  padding-left: 30px;
}

.foot-box .recommendBtn-flex {
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.foot-box .recommendBtn-flex .recommendBtn {
  float: left !important;
  width: 60% !important;
}

.foot-box .recommendBtn-flex .recommend-btn {
  float: left !important;
  width: 80% !important;
}

.foot-box .recommendBtn-flex-flex {
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding-right: 15px;
}

.foot-box .recommendBtn-flex-flex .recommendBtn {
  float: left !important;
  width: 60% !important;
}

.foot-box .recommendBtn-flex-flex .recommend-btn {
  float: left !important;
  width: 80% !important;
  border-radius: 20px;
}

.filled {
  color: #910000;
}

.recommend-save {
  display: flex;
  width: 100%;
  justify-content: center;
  background: #fff;
  padding: 2vh 0;

  .saveBtn {
    width: 90%;
    border-radius: 50px;
    background: #910000;
    color: #fff;
    padding: 12px 0;
    font-size: 16px;
  }
}

.compare-list {
  padding-bottom: 3vh;
  background: #f7f5f4;

  .compare-list-title {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    padding: 0 16px;
    height: 7vh;
    display: flex;
    align-items: center;
    background: #fff;
  }

  .compare-list-content {
    height: calc(62vh - 15px);
    overflow-y: auto;
    width: 100%;
    padding: 0 15px;
    padding-top: 15px;
  }

  .compare-list-item {
    padding: 0 10px 10px 13px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;

    .compare-list-item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .index {
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 0 0 5px 5px;
      background-color: #910000;
      color: #fff;
      margin-right: 10px;
    }

    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .compare-list-item-cont {
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
      margin-bottom: 10px;

      h1.bf {
        font-size: 20px;
        width: 24px;
        white-space: nowrap;

        .fb {
          margin-left: -9px;
          font-size: 12px;
        }
      }

      .cont-text {
        width: calc(100% - 78px);

        .cont-text-name {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #262626;
          line-height: 24px;
          margin-bottom: 5px;
        }

        .pad_top {
          padding-top: 10px;
        }

        .zy-remark {
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
          line-height: 18px;
        }
      }

      .del {
        width: 24px;
        text-align: right;

        .el-icon-delete {
          font-size: 18px;
          color: #999;
        }
      }
    }
  }
}

.el-slider__bar {
  height: 6px;
  background-color: #910000;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: absolute;
}

.el-slider__button {
  border: 2px solid #910000;
}

.job {

  .van-dropdown-menu__item:nth-child(2),
  .van-dropdown-menu__item:nth-child(3) {
    .van-dropdown-menu__title::after {
      display: none;
    }
  }
}

.van-dropdown-menu__title--active {
  color: #910000;
}

.backTop {
  position: fixed;
  z-index: 999;
  right: 3vw;
  bottom: 15vh;

  img {
    width: 50px;
    border-radius: 50px;
    // background: #fff;
    // border:1px solid #ddd;
  }
}

.show_vip {
  position: absolute;
  z-index: 8;
  background: rgba(0, 0, 0, 0);
  width: 100%;
  top: -3px;
  height: 25px;
}

.recentYears {

  // width: 50%;
  th {
    font-weight: bold;

    .yearName {
      white-space: nowrap;
      font-size: 13px;
    }

    div {
      display: flex;
      align-items: center;

      span {
        display: inline-flex;
        align-content: center;
        flex-wrap: wrap;
        width: 15px;

        i:nth-child(2) {
          margin-top: -8px;
        }
      }
    }
  }

  td {
    font-size: 14px;
    color: #910000;
  }
}

.el-tooltip__popper {
  max-width: 95%;
  font-size: 15px;
  line-height: 22px;
}

.admissions {

  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .font {
    // font-size: 15px;
    // font-weight: bold;
    padding: 0 0 0 6px;
  }
}
</style>
